(function (lib, img, cjs, ss, an) {

var p; // shortcut to reference prototypes
lib.ssMetadata = [
		{name:"MWpolar_atlas_", frames: [[1588,1034,208,208],[1798,1034,176,176],[1102,1278,240,394],[1806,422,240,394],[1104,882,240,394],[1346,882,240,394],[1344,1278,234,394],[588,1266,256,382],[846,882,256,382],[1548,422,256,382],[588,882,256,382],[846,1266,254,382],[1768,1726,246,214],[1588,818,222,214],[1580,1278,266,222],[1580,1502,266,222],[1812,818,224,212],[588,1650,268,222],[272,1754,266,238],[0,1754,270,260],[1066,1674,246,226],[1116,422,214,458],[900,422,214,458],[684,422,214,458],[1332,422,214,458],[294,854,292,448],[0,1304,292,448],[0,854,292,448],[294,1304,292,448],[1314,1674,204,270],[858,1650,206,282],[1848,1212,92,164],[684,0,680,420],[1366,0,680,420],[0,0,682,430],[1520,1726,246,214],[0,432,682,420]]}
];


// symbols:



(lib.M_Wash_Bubble = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(0);
}).prototype = p = new cjs.Sprite();



(lib.M_Wash_Bubble_pop = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(1);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearFrontLegBack_0010001 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(2);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearFrontLegBack_0010002 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(3);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearFrontLegBack_0010003 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(4);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearFrontLegBack_0010004 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(5);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearFrontLegBack_excited_roar_001 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(6);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearFrontLeg0001 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(7);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearFrontLeg0002 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(8);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearFrontLeg0003 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(9);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearFrontLeg0004 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(10);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearFront_excited_roar_001 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(11);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHead0001 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(12);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHead_0020002 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(13);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHead_0030001 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(14);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHead_excited_roar_001 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(15);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHead_excited_roar_002 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(16);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHead_roar_001 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(17);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHead_roar_002 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(18);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHead_roar_003 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(19);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHead_wet = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(20);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHindLegBack0001 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(21);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHindLegBack0002 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(22);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHindLegBack0003 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(23);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHindLegBack0004 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(24);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHindLeg0001 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(25);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHindLeg0002 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(26);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHindLeg0003 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(27);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearHindLeg0004 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(28);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearNeck = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(29);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearNeck_wet = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(30);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearTail = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(31);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearTorso0001 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(32);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearTorso0002 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(33);
}).prototype = p = new cjs.Sprite();



(lib.PolarBearTorso_wet0001 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(34);
}).prototype = p = new cjs.Sprite();



(lib.polarbear_excited_head_003 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(35);
}).prototype = p = new cjs.Sprite();



(lib.polarbear_excited_torso_001 = function() {
	this.spriteSheet = ss["MWpolar_atlas_"];
	this.gotoAndStop(36);
}).prototype = p = new cjs.Sprite();
// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.Wet_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#91D6F7").s().p("AgeBSQgPgSgCgjQgCgiAkheQA2BhAFAgQAFAkgOARQgOARgUAAQgTAAgOgSg");
	this.shape.setTransform(4.8,10);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,9.6,20);


(lib.SmallStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("Ag1BSQgGgDAFgaIAHgaIgVgVQgVgUADgFQACgFAbgFIAbgFIAMgYQAOgYAEAAQAHAAAYAyIAbADQAbAEACAGQAEAJgtAlQAPAzgHAEQgHAEgvgaQgkAXgNAAIgEgBg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-8.7,-8.3,17.6,16.7);


(lib.LargeStar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF99").s().p("AhGBuQgJgFAHgjIAJgiIgcgbQgbgcADgGQADgHAkgHIAjgGIARggQATghAFABQAKgBAgBDIAjAEQAkAGADAIQAFAMg7AxQAUBEgKAGQgKAFg+gjQgwAegRAAIgFAAg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.6,-11,23.4,22.1);


(lib.sparkle = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFFFF").s().p("AgZAGQAYgRABg2QACA2AYANQgWAVgDArQgIgxgSgLg");
	this.shape.setTransform(-0.1,1);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AggAkQgLgQgMgHQANgKAKgOQAdgsADhXQAEBYAeAoQAJAMAMAHIABAAQgNALgJAQQgaApgFBFIAAABQgNhJgWgig");
	this.shape_1.setTransform(-0.1,1);

	this.shape_2 = new cjs.Shape();
	this.shape_2.graphics.f("#FFFFFF").s().p("AgyA5QgQgZgTgMQAUgPAPgWQAthEAFiHQAGCJAvA9QAOAUASAKQgSASgOAYQgpBAgHBrQgVhwgig0gAgZAGQASALAIAxQAEgsAVgUQgYgNgCg3QgBA3gYARg");
	this.shape_2.setTransform(-0.1,1);

	this.shape_3 = new cjs.Shape();
	this.shape_3.graphics.f("#FFFFFF").s().p("Ag0BYQA1AmAzgmQgnBAgHBqQgWh2gkg0gAhxAKQATgNAPgYQgVAlAVAlQgQgZgSgMgABRgfQAOATATALQgTARgOAYQAUglgUgigAgrhAQAnhDAEh9QAHCDAqA9QgugpguApg");
	this.shape_3.setTransform(-0.2,2);

	this.shape_4 = new cjs.Shape();
	this.shape_4.graphics.f("#FFFFFF").s().p("AgMC8QAQAaAOgaQgIAlgEAtQgHgugLgkgAh7ALIASgPQgMARALAMQgIgJgJgFgABvgJIANAJIgNAMQAIgMgIgJgAgJisQAIgrABg2QADA3AJAqQgLgOgKAOg");
	this.shape_4.setTransform(-0.3,1.9);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.shape_1}]},1).to({state:[{t:this.shape_2}]},1).to({state:[{t:this.shape_3}]},1).to({state:[{t:this.shape_4}]},1).to({state:[]},1).wait(45));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-2.7,-5.7,5.2,13.3);


(lib.polarbear_pawMud_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{dirty:0,dirty_stop:1,clean:2,clean_loop:3,glow:4,glow_loop:5,wash:6,wash_stop:209,glowclean:210,glowclean_loop:211,"final":212,final_loop:213});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("ABWBgQg8gDg0AIQhpgUhmgMIAAgBIgJgEIgGAAIgKgGIgEgHIglgOIgDgHIgHgCIgVgfIgBgRQABgKAFgJQAJgTAPAAIAFABQgFgPAAgFQgBgGACgGQAEgMAMAAQARABAlARQATAKAKAHQAOABANAHIACABIAFAMIAKAEIAEAEIACAAQAXAAASALIAHAAIAKAGIALACIAIAJIAUAGIAEgPQAngBAjAHIBLAZIAAABQASAHAOgGQAEAAAAgDQADgMgBgNQALgXANgUIAPgCIAWgLQARAPAKADIBkAZIADALQADANABAQIgTAdIAAACIAAAAIAAABIgBADQgEAMgGAJQgNAHgPAFQgeAKgxAKQg3gCg2gEg");
	this.shape.setTransform(33.2,14.9);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},2).wait(2).to({_off:false},0).to({_off:true},2).wait(208));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,4.7,66.4,20.3);


(lib.polarbear_noseGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(5,1,1).p("AChgFQAAgmgVgoQgVgngggbQghgcghgDQgjgEgZAcQgVAWgQAUQgDADgDAEQgIAJgGAIQgPAFgBAOQgGAJgGAIIgJAMQgaApgBAOQAAAEgBAGQgBAGABALQABALAAABIAAAAIACAJQACAIAEAPQADALAFAIIAHALQAGAHAJAEQAHACALADQADADAEADQARANAVALQAqAWAZAAQA7AAAlgqQAYgaADgSQABgBAAAAQAJgDAGgHQAGgHAAgJQAAgCAAgBQAJgSABgXQgCgZAAgFg");
	this.shape.setTransform(16.3,18.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.polarbear_noseGlow, new cjs.Rectangle(-2.5,-2.5,37.6,41.4), null);


(lib.polarbear_legMud_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"glowclean":210,"glowclean_loop":211,"final":212,"final_loop":213});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AB/KLQgvhEgIAAQgMAAgeAKQgeAJgMAAQguAAhRgzQg/gngLgFQgGgCgMgCIgggBIitgIQhVgEAFhuQACgmgCgiQgEhDgTg4QgchWgahxQgZhxBAjEQBAjDCUA7QBEjqBeCNQBeCOBeiMQB9jCB7CEQCkCvB4g3IAWgJIAFAGIADAAQAAA2ARA1QACAGgCAIIAGAYQAGAIACAQIAAAQQgIAGgLACIgQAAQgFAnAFAmQABAFgDAJIgGAIQgDAEgHACQgJAAgLgBIgBATQAGgBADADQAFAFABAGIAIADIAJAQIgBASQgGADgEAFQgFAHgCAEIgZADIAKAKIACAIIAKALIACACIADAAIADADIASAGIAHAQIgOAFIgJAGQglAJgpgBIgCAAQAIA1gHA8IAAAOIgTAAIgFgGIgKgFQAAgDgDgBQgFgDgHgBIgDAgQAFAKAHALQAEAFAAAGIAFADIAIAnIAEAOIACAEIgJAUIgSAAIgKgNIgEAtQgCAfgUAXIgFADIgEAHIgaAWQgLgDgEgNIgCgDIABgCQACgGgFAAIABgTQgJAZgBAnIgGAGIgDAKIgDAEQgDAFgFAAIgKgJQgFAHgCAMIgBALIAKALIAKAFIgBANIgbAAIgEAWIgPAYIACAKIgBALIgGAIIgGADIAAAIIgPASQACAEgFADQgFACgGgBQgFAQgNALIgIAAIABAYQgKgCgFAFQgCADAAAFQAGAUgFAXIgCAFQgOANgXABIgOgQgAlfJXQAKg5AvAoQCbgzhhBZQgUADg1AQQgMAEgJAAQgeAAAJgsg");
	this.shape.setTransform(61.6,82.1);

	this.timeline.addTween(cjs.Tween.get(this.shape).to({_off:true},2).wait(2).to({_off:false},0).to({_off:true},2).wait(208));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(1.6,15.5,120.2,133.4);


(lib.polarbear_legGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(5,1,1).p("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");
	this.shape.setTransform(6.5,66.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.polarbear_legGlow, new cjs.Rectangle(-110.9,-0.7,234.7,134.8), null);


(lib.polarbear_footGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FFFF00").s().p("AnwCvIgnAAIgEAAQgqgGgdgGIgXABQgqAAgKgIQgPgEgBgVQgSgDgFgGIgCgBQgPgGACgcQgBgWAXgSQAJgRAUgIIACgBIBJgSIAJgHIABgBQAKgIATgCIgBAAIAKgCIAAgBIABAAIABAAQAUgKAXgFIABgBIACgDQAPgYBoACIAAAAQBfACAtAaQAbAAAJAYIASANQAGAFADAIQADAHgBAIIgDAQIAAAAQgEAWgHAQIAAAAIAAABQgGAQgJAJQgPATgqAIIgCAAQhlAMhsAWIgFAAIgBAAgAqDCBIgBABQABAAAAAAQABAAAAgBQAAAAAAgBQABgBAAgBIgCADgApbBnQAdAHApAFIAiAAQBsgVBlgMQARgDAHgFIADgHIABgDQAEgJADgNIgKgHIgGgGQgGgCgEgDQgkgWhSgCIhFgBQgDAEgEADIgBAAIAAABIgBACQgDAFgFAEQgGAEgHABQgWADgRAJIgCABQgLAFgRACIAAAAQgTAQgMACIgBAAIhCARIAEADIAHAFQAIAEAEAIIADAGIAGAAQAKAAAHgBIAGgBIAHABgAqnBbIAAACIADgCQAHgFAEgIIgCAAIACgBIABAAIgBgBIAAABQgHgFgKAAQgGAAgCABIACABIAFARQASgLgIAIIgEADQAAAAAAAAQgBABAAgBQAAAAAAAAQgBAAAAgBIAAABgAFSCmIgEAAQgpgGgegGIgWABQgrAAgJgIQgQgEgBgWQgRgCgGgGIgBgBQgQgHACgcQAAgVAWgTQAJgQAVgJIACgBIBJgRIAIgHIACgBQAJgJAUgCIgBAAIAKgCIAAAAIAAAAIABgBQAUgKAXgFIABgBIACgCQAPgZBoACIABAAQBeACAuAbQAbAAAJAYIAEADQAJgQAUgIIACgBIBJgSIAJgIIABgBQAKgIATgCIgBAAIAKgCIAAgBIABAAIABAAQATgKAYgFIABgBIACgDQAPgYBoACIAAAAQBeACAuAaQAbAAAJAYIASAOQAGAFADAIQADAHgBAIIgDAQIAAAAQgEAVgHAQIAAAAIAAABQgGAQgJAJQgPATgqAIIgCAAQhlAMhsAWIgGAAIgnAAIgEAAQgqgGgdgGIgXABQgqAAgKgIQgPgEgBgVIgCAAIgDAHIgBABIAAAAQgGAQgJAKQgPASgpAIIgCABQhmALhrAWIgGABgADmB4IAAAAQAAABABAAQAAAAAAgBQABAAAAgBQAAgBAAgCIgCAEgAEPBeQAcAGAqAGIAhAAQBsgWBmgMQAQgDAHgFQACgCABgEIACgEQAEgJACgNIgKgHIgGgGQgFgBgFgDQgkgWhSgCQg+gBgGgBQgDAFgFAEIAAAAIAAAAIgCACQgDAFgFADQgGAEgHACQgWADgRAJIgCAAQgLAFgQADIgBAAQgTAPgMACIAAABIhDAQIAEADIAIAGQAHAEAFAHIACAHIAHAAQAJAAAIgCIAGAAIAHABgADCBSIAAABIACgBQAAAAAAAAQAAAAgBAAQAAAAAAAAQAAgBgBAAgADFBSIABgBIADgCIgEADgAC4BAIABABQADALACAFQASgKgHAIQAFgFACgGIgBAAIABAAIABAAQAAAAAAAAQAAAAAAAAQAAgBAAAAQAAAAAAAAIgBABQgHgGgJAAQgHAAgBACgALaBFIgBABQABAAAAAAQABAAAAAAQAAgBAAgBQABgBAAgBIgCADgAMCArQAcAHAqAFIAiAAQBsgVBlgMQARgDAHgFQACgDABgEIABgDQAEgIADgNIgKgHIgGgGQgGgCgEgDQgkgXhSgBQg+gBgHgBQgDAFgEADIgBAAIAAABIgBACQgEAFgEAEQgGAEgHABQgWADgRAJIgCABQgLAFgRACIAAAAQgTAQgMABIgBAAIhCARIAEADIAHAFQAIAEAEAIIADAGIAGAAQAKAAAHgBIAGgBIAHABgAK2AfIAAACIACgBIgCgCgAK4AfIABAAIADgDIgEADgAKrANIACABQACALADAGQASgLgIAIQAFgEADgGIgCAAIACgBIABAAQAAAAAAAAQgBAAAAAAQAAAAAAAAQAAAAAAgBIAAABQgIgFgJAAQgGAAgCABgAvPA8IgEAAQgqgGgdgGIgXABQgqAAgKgIQgPgEgBgVQgSgDgFgGIgCgBQgPgGACgbQgBgWAXgSQAIgRAVgIIACgBIBJgSIAJgIIABgBQAKgIATgCIgBAAIAKgCIAAgBIABAAIABAAQATgKAYgFIABgBIACgDQAPgYBoACIAAAAQBeACAuAaQAbAAAJAYIASAOQAGAFADAIQADAHgBAIIgDAQIAAAAQgEAWgHAQIAAAAIAAABQgGAQgJAJQgPASgqAIIgCAAQhlAMhsAWIgGAAgAw7AOIgBABQABAAAAAAQABAAAAAAQAAgBAAgBQABgBAAgBIgCADgAwTgLQAcAHAqAEIAiAAQBsgUBlgMQARgDAHgFQACgDABgEIABgDQAEgJADgNIgKgHIgGgGQgGgCgEgDQgkgXhSgBQg+gBgHgBQgDAFgEADIgBAAIAAABIgBACQgEAFgEAEQgGAEgHABQgWADgRAJIgCABQgLAFgRACIAAAAQgTAQgMACIgBAAIhCARIgCAAIACgBQgIgFgJAAQgGAAgCABIACABQACALADAGQASgLgIAIIgEADIABAAIADgDQAFgEADgGIAEADIAHAFQAIAEAEAIIADAGIAGAAQAKAAAHgBIAGgBIAHABgAxfgXIAAACIACgBQAAAAgBAAQAAAAAAAAQAAgBgBAAQAAAAAAgBgAxRglIABAAQAAAAAAAAQgBAAAAAAQAAAAAAAAQAAAAAAgBIAAABg");
	this.shape.setTransform(71,3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.polarbear_footGlow, new cjs.Rectangle(-47,-14.5,236,35.1), null);


(lib.polarbear_backGlow = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFF00").ss(5,1,1).p("ALKg9QgXAkhTBPQhpBkjBA0QjsBAlXgQQhRgEhbgMQhbgMg0hUQgzhUhOjoQBAg3BjBKQBYBOBegsQBNgmDDgyQGciOGOEig");
	this.shape.setTransform(85.4,29.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.polarbear_backGlow, new cjs.Rectangle(11.5,1.5,147.7,56.4), null);


(lib.PolarBearHead_roar_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Polar Bear Head_roar_003.png
	this.instance = new lib.PolarBearHead_roar_003();
	this.instance.parent = this;
	this.instance.setTransform(-47.8,-54.8,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-47.8,-54.8,135,130);


(lib.PolarBearHead_roar_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Polar Bear Head_roar_002.png
	this.instance = new lib.PolarBearHead_roar_002();
	this.instance.parent = this;
	this.instance.setTransform(-48,-54.6,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-48,-54.6,133,119);


(lib.PolarBearHead_roar_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 10
	this.instance = new lib.PolarBearHead_roar_001();
	this.instance.parent = this;
	this.instance.setTransform(-47.8,-54.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-47.8,-54.7,134,111);


(lib.PolarBearHead_excited_roar_002_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.PolarBearHead_excited_roar_002();
	this.instance.parent = this;
	this.instance.setTransform(-48.5,-50.1,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-48.5,-51,112,106.9);


(lib.PolarBearHead_excited_roar_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Polar Bear Head_excited_roar_001.png copy
	this.instance = new lib.PolarBearHead_excited_roar_001();
	this.instance.parent = this;
	this.instance.setTransform(-47.9,-54.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-47.9,-54.7,133,111);


(lib.M_Wash_Bubble_pop_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble_pop();
	this.instance.parent = this;
	this.instance.setTransform(-9,-9,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1.9,1,1).p("AAtACIARAAAACg9IAAAUAAgghIAJgMAg9AAIAYgBAgmgrIANAPAgrArIALgNAgEAwIAAAOAAdAoIAKAN");
	this.shape.setTransform(11.2,10.6);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_pop_1, new cjs.Rectangle(-9,-9,44,44), null);


(lib.M_Wash_Bubble_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.M_Wash_Bubble();
	this.instance.parent = this;
	this.instance.setTransform(-13,-13,0.25,0.25);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.M_Wash_Bubble_1, new cjs.Rectangle(-13,-13,52,52), null);


(lib.legsglowblue = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(5,1,1).p("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");
	this.shape.setTransform(6.5,66.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.legsglowblue, new cjs.Rectangle(-110.9,-0.7,234.7,134.8), null);


(lib.invisiblebox = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(255,255,255,0)").s().p("AhwDIIhZgEIAEmHIBOgEIDvAAIBSABIgCGKIhGAEg");
	this.shape.setTransform(-0.3,0);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.invisiblebox, new cjs.Rectangle(-20.5,-20,40.4,40), null);


(lib.bluenoseglow3 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(5,1,1).p("AChgFQAAgmgVgoQgVgngggbQghgcghgDQgjgEgZAcQgVAWgQAUQgDADgDAEQgIAJgGAIQgPAFgBAOQgGAJgGAIIgJAMQgaApgBAOQAAAEgBAGQgBAGABALQABALAAABIAAAAIACAJQACAIAEAPQADALAFAIIAHALQAGAHAJAEQAHACALADQADADAEADQARANAVALQAqAWAZAAQA7AAAlgqQAYgaADgSQABgBAAAAQAJgDAGgHQAGgHAAgJQAAgCAAgBQAJgSABgXQgCgZAAgFg");
	this.shape.setTransform(16.3,18.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.bluenoseglow3, new cjs.Rectangle(-2.5,-2.5,37.6,41.4), null);


(lib.bluenoseglow2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(5,1,1).p("AChgFQAAgmgVgoQgVgngggbQghgcghgDQgjgEgZAcQgVAWgQAUQgDADgDAEQgIAJgGAIQgPAFgBAOQgGAJgGAIIgJAMQgaApgBAOQAAAEgBAGQgBAGABALQABALAAABIAAAAIACAJQACAIAEAPQADALAFAIIAHALQAGAHAJAEQAHACALADQADADAEADQARANAVALQAqAWAZAAQA7AAAlgqQAYgaADgSQABgBAAAAQAJgDAGgHQAGgHAAgJQAAgCAAgBQAJgSABgXQgCgZAAgFg");
	this.shape.setTransform(16.3,18.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.bluenoseglow2, new cjs.Rectangle(-2.5,-2.5,37.6,41.4), null);


(lib.blueglowpaws = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#0099FF").s().p("AnwCvIgnAAIgEAAQgqgGgdgGIgXABQgqAAgKgIQgPgEgBgVQgSgDgFgGIgCgBQgPgGACgcQgBgWAXgSQAJgRAUgIIACgBIBJgSIAJgHIABgBQAKgIATgCIgBAAIAKgCIAAgBIABAAIABAAQAUgKAXgFIABgBIACgDQAPgYBoACIAAAAQBfACAtAaQAbAAAJAYIASANQAGAFADAIQADAHgBAIIgDAQIAAAAQgEAWgHAQIAAAAIAAABQgGAQgJAJQgPATgqAIIgCAAQhlAMhsAWIgFAAIgBAAgAqDCBIgBABQABAAAAAAQABAAAAgBQAAAAAAgBQABgBAAgBIgCADgApbBnQAdAHApAFIAiAAQBsgVBlgMQARgDAHgFIADgHIABgDQAEgJADgNIgKgHIgGgGQgGgCgEgDQgkgWhSgCIhFgBQgDAEgEADIgBAAIAAABIgBACQgDAFgFAEQgGAEgHABQgWADgRAJIgCABQgLAFgRACIAAAAQgTAQgMACIgBAAIhCARIAEADIAHAFQAIAEAEAIIADAGIAGAAQAKAAAHgBIAGgBIAHABgAqnBbIAAACIADgCQAHgFAEgIIgCAAIACgBIABAAIgBgBIAAABQgHgFgKAAQgGAAgCABIACABIAFARQASgLgIAIIgEADQAAAAAAAAQgBABAAgBQAAAAAAAAQgBAAAAgBIAAABgAFSCmIgEAAQgpgGgegGIgWABQgrAAgJgIQgQgEgBgWQgRgCgGgGIgBgBQgQgHACgcQAAgVAWgTQAJgQAVgJIACgBIBJgRIAIgHIACgBQAJgJAUgCIgBAAIAKgCIAAAAIAAAAIABgBQAUgKAXgFIABgBIACgCQAPgZBoACIABAAQBeACAuAbQAbAAAJAYIAEADQAJgQAUgIIACgBIBJgSIAJgIIABgBQAKgIATgCIgBAAIAKgCIAAgBIABAAIABAAQATgKAYgFIABgBIACgDQAPgYBoACIAAAAQBeACAuAaQAbAAAJAYIASAOQAGAFADAIQADAHgBAIIgDAQIAAAAQgEAVgHAQIAAAAIAAABQgGAQgJAJQgPATgqAIIgCAAQhlAMhsAWIgGAAIgnAAIgEAAQgqgGgdgGIgXABQgqAAgKgIQgPgEgBgVIgCAAIgDAHIgBABIAAAAQgGAQgJAKQgPASgpAIIgCABQhmALhrAWIgGABgADmB4IAAAAQAAABABAAQAAAAAAgBQABAAAAgBQAAgBAAgCIgCAEgAEPBeQAcAGAqAGIAhAAQBsgWBmgMQAQgDAHgFQACgCABgEIACgEQAEgJACgNIgKgHIgGgGQgFgBgFgDQgkgWhSgCQg+gBgGgBQgDAFgFAEIAAAAIAAAAIgCACQgDAFgFADQgGAEgHACQgWADgRAJIgCAAQgLAFgQADIgBAAQgTAPgMACIAAABIhDAQIAEADIAIAGQAHAEAFAHIACAHIAHAAQAJAAAIgCIAGAAIAHABgADCBSIAAABIACgBQAAAAAAAAQAAAAgBAAQAAAAAAAAQAAgBgBAAgADJBPIgEADIABgBIADgCQAFgFACgGIgBAAIABAAIABAAQAAAAAAAAQAAAAAAAAQAAgBAAAAQAAAAAAAAIgBABQgHgGgJAAQgHAAgBACIABABQADALACAFQALgGACAAQAAAAAAABQAAAAAAAAQAAABgBAAQAAABgBABgALaBFIgBABQABAAAAAAQABAAAAAAQAAgBAAgBQABgBAAgBIgCADgAMCArQAcAHAqAFIAiAAQBsgVBlgMQARgDAHgFQACgDABgEIABgDQAEgIADgNIgKgHIgGgGQgGgCgEgDQgkgXhSgBQg+gBgHgBQgDAFgEADIgBAAIAAABIgBACQgEAFgEAEQgGAEgHABQgWADgRAJIgCABQgLAFgRACIAAAAQgTAQgMABIgBAAIhCARIgCAAIACgBIABAAQAAAAAAAAQgBAAAAAAQAAAAAAAAQAAAAAAgBIAAABQgIgFgJAAQgGAAgCABIACABQACALADAGQASgLgIAIIgEADIABAAIADgDQAFgEADgGIAEADIAHAFQAIAEAEAIIADAGIAGAAQAKAAAHgBIAGgBIAHABgAK2AfIAAACIACgBIgCgCgAvPA8IgEAAQgqgGgdgGIgXABQgqAAgKgIQgPgEgBgVQgSgDgFgGIgCgBQgPgGACgbQgBgWAXgSQAIgRAVgIIACgBIBJgSIAJgIIABgBQAKgIATgCIgBAAIAKgCIAAgBIABAAIABAAQATgKAYgFIABgBIACgDQAPgYBoACIAAAAQBeACAuAaQAbAAAJAYIASAOQAGAFADAIQADAHgBAIIgDAQIAAAAQgEAWgHAQIAAAAIAAABQgGAQgJAJQgPASgqAIIgCAAQhlAMhsAWIgGAAgAw7AOIgBABQABAAAAAAQABAAAAAAQAAgBAAgBQABgBAAgBIgCADgAwTgLQAcAHAqAEIAiAAQBsgUBlgMQARgDAHgFQACgDABgEIABgDQAEgJADgNIgKgHIgGgGQgGgCgEgDQgkgXhSgBQg+gBgHgBQgDAFgEADIgBAAIAAABIgBACQgEAFgEAEQgGAEgHABQgWADgRAJIgCABQgLAFgRACIAAAAQgTAQgMACIgBAAIhCARIgCAAIACgBIABAAQAAAAAAAAQgBAAAAAAQAAAAAAAAQAAAAAAgBIAAABQgIgFgJAAQgGAAgCABIACABQACALADAGQASgLgIAIIgEADIABAAIADgDQAFgEADgGIAEADIAHAFQAIAEAEAIIADAGIAGAAQAKAAAHgBIAGgBIAHABgAxfgXIAAACIACgBQAAAAgBAAQAAAAAAAAQAAgBgBAAQAAAAAAgBg");
	this.shape.setTransform(71,3);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowpaws, new cjs.Rectangle(-47,-14.5,236,35.1), null);


(lib.blueglownose = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(5,1,1).p("AChgFQAAgmgVgoQgVgngggbQghgcghgDQgjgEgZAcQgVAWgQAUQgDADgDAEQgIAJgGAIQgPAFgBAOQgGAJgGAIIgJAMQgaApgBAOQAAAEgBAGQgBAGABALQABALAAABIAAAAIACAJQACAIAEAPQADALAFAIIAHALQAGAHAJAEQAHACALADQADADAEADQARANAVALQAqAWAZAAQA7AAAlgqQAYgaADgSQABgBAAAAQAJgDAGgHQAGgHAAgJQAAgCAAgBQAJgSABgXQgCgZAAgFg");
	this.shape.setTransform(16.3,18.2);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglownose, new cjs.Rectangle(-2.5,-2.5,37.6,41.4), null);


(lib.blueglowback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0099FF").ss(5,1,1).p("ALKg9QgXAkhTBPQhpBkjBA0QjsBAlXgQQhRgEhbgMQhbgMg0hUQgzhUhOjoQBAg3BjBKQBYBOBegsQBNgmDDgyQGciOGOEig");
	this.shape.setTransform(85.4,29.7);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

}).prototype = getMCSymbolPrototype(lib.blueglowback, new cjs.Rectangle(11.5,1.5,147.7,56.4), null);


(lib.polarbear_excited_torso_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// polarbear_excited_torso_001.png copy
	this.instance = new lib.polarbear_excited_torso_001();
	this.instance.parent = this;
	this.instance.setTransform(-167.7,-98.8,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-167.7,-99.1,341,210.3);


(lib.polarbear_excited_rtarm_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 4
	this.instance = new lib.PolarBearFrontLegBack_excited_roar_001();
	this.instance.parent = this;
	this.instance.setTransform(-56.6,-96.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-56.6,-96.5,117,197);


(lib.polarbear_excited_ltarm_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.PolarBearFront_excited_roar_001();
	this.instance.parent = this;
	this.instance.setTransform(-60,-90.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-75.1,-90.4,142.1,191);


(lib.PolarBearTorso_wet = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"final":0,"final_loop":1});

	// Polar Bear Torso_wet0001.png copy
	this.instance = new lib.PolarBearTorso_wet0001();
	this.instance.parent = this;
	this.instance.setTransform(-167.5,-99.6,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-167.5,-103.4,341,218.8);


(lib.PolarBearTail_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.PolarBearTail();
	this.instance.parent = this;
	this.instance.setTransform(-101.3,-42,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-101.3,-42,46,82);


(lib.PolarBearNeck_wet_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.PolarBearNeck_wet();
	this.instance.parent = this;
	this.instance.setTransform(-50.1,-65.9,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-50.1,-65.9,103,141);


(lib.PolarBearNeck_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Polar Bear Neck.png copy
	this.instance = new lib.PolarBearNeck();
	this.instance.parent = this;
	this.instance.setTransform(-50,-65.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-50,-65.4,102,135);


(lib.PolarBearFrontLegBack_excited_roar_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Polar Bear Front Leg Back_excited_roar_001.png copy
	this.instance = new lib.PolarBearFrontLegBack_excited_roar_001();
	this.instance.parent = this;
	this.instance.setTransform(-56.6,-96.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-56.6,-96.5,117,197);


(lib.PolarBearFront_excited_roar_001_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 3
	this.instance = new lib.PolarBearFront_excited_roar_001();
	this.instance.parent = this;
	this.instance.setTransform(-60,-90.4,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-75.1,-90.4,142.1,191);


(lib.polarbear_excited_head_003_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.polarbear_excited_head_003();
	this.instance.parent = this;
	this.instance.setTransform(-58.8,-50,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-58.8,-50,123,107);


(lib.PolarBearHead_wet_1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"final":0,"final_loop":1});

	// Layer 2
	this.instance = new lib.PolarBearHead_wet();
	this.instance.parent = this;
	this.instance.setTransform(-58.8,-50,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({_off:true},2).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-58.8,-50,123,113);


(lib.PolarBearHead_excited_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// polarbear_excited_head_003.png
	this.instance = new lib.polarbear_excited_head_003();
	this.instance.parent = this;
	this.instance.setTransform(-58.8,-50,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

}).prototype = getMCSymbolPrototype(lib.PolarBearHead_excited_003, new cjs.Rectangle(-58.8,-50,123,107), null);


(lib.star_2_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.SmallStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,-4.2,-0.7,-6.2,-1.6,-9.1,-2.8,-9.1,-4.5,-9.1,-6.3,-6,-7.7,-4.2,-8.6,0.7,-10,5.6,-11.4,7.5,-12.3,10.6,-13.8,10.6,-15.6,10.6,-17.5,7.3,-18.9,5.3,-19.8,0.1,-21.1,-5.1,-22.4,-7,-23.2,-10.3,-24.5,-10.3,-26.3,-10.3,-28,-7.2,-29.3,-5.7,-30,-1.7,-31.1], orient:'auto'},alpha:0.102},16).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-5.1,-4.7,10.5,10);


(lib.star_1_anim = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Star
	this.instance = new lib.LargeStar("synched",0);
	this.instance.parent = this;
	this.instance.setTransform(0.1,0.3,0.6,0.6);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({guide:{path:[0.1,0.2,4.5,-0.7,6.5,-1.6,9.4,-2.8,9.4,-4.5,9.4,-6.3,6.3,-7.7,4.5,-8.6,-0.4,-10,-5.3,-11.4,-7.2,-12.3,-10.3,-13.8,-10.3,-15.6,-10.3,-17.5,-7,-18.9,-5,-19.8,0.1,-21.1,5.4,-22.4,7.3,-23.2,10.6,-24.5,10.6,-26.3,10.6,-28,7.5,-29.3,6,-30,2,-31.1], orient:'auto'},alpha:0.102},13).wait(1));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-6.9,-6.4,14,13.3);


(lib.sparkle2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_2_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle2, new cjs.Rectangle(-5.2,-4.7,10.6,10), null);


(lib.sparkle1 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.innerSparkle = new lib.star_1_anim();
	this.innerSparkle.parent = this;

	this.timeline.addTween(cjs.Tween.get(this.innerSparkle).wait(1));

}).prototype = getMCSymbolPrototype(lib.sparkle1, new cjs.Rectangle(-6.9,-6.4,14,13.3), null);


(lib.Running_drop = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 1
	this.instance = new lib.Wet_drop();
	this.instance.parent = this;
	this.instance.setTransform(4.8,10,1,1,0,0,0,4.8,10);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,4);
	new cjs.ButtonHelper(this.instance, 0, 1, 1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({y:146.2},15).to({regX:4.5,scaleX:0.1,scaleY:0.1,y:182.5},4).to({_off:true},1).wait(5));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-10,-10,37,48);


(lib.left_over_bubbles_sparse = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(59.6,9,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_sparse, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles_few = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(42.3,6.2,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(43.3,4.3,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(39.9,6.5,0.075,0.075,-155.3,0,0,11.1,11.2);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(54,11,0.075,0.075,-155.3,0,0,11,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(46.5,10.1,0.439,0.439,-153.7,0,0,11.2,11.1);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(52.8,6.1,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles_few, new cjs.Rectangle(23.8,-13.3,50.1,48), null);


(lib.left_over_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 15
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(70.8,4,0.404,0.404,4.9,0,0,11.1,10.3);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(64.4,1.4,0.289,0.289,4.9,0,0,11.1,10.3);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(31,4.8,0.289,0.289,4.9,0,0,11.1,10);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(29.7,12.7,0.431,0.431,4.9,0,0,11.3,11.2);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(34.6,7,0.253,0.253,160.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(55.1,9,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(47.2,-5.1,0.267,0.267,-155.4,0,0,11.5,11.1);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(20.1,12.2,0.221,0.221,-155.4,0,0,11.3,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(20.2,17,0.162,0.162,-155.3,0,0,11.2,11.1);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(38.2,13,0.188,0.188,-155.4,0,0,11.1,10.7);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(40.7,8.6,0.28,0.28,-155.4,0,0,11.2,11.2);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(82.6,4.9,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(36.5,10.9,0.165,0.165,0,0,0,11,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12},{t:this.instance_11},{t:this.instance_10},{t:this.instance_9},{t:this.instance_8},{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]}).wait(1));

}).prototype = getMCSymbolPrototype(lib.left_over_bubbles, new cjs.Rectangle(5.3,-21.9,91.8,57.3), null);


(lib.Bubbles_together = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// M_Wash_Bubble
	this.instance = new lib.M_Wash_Bubble_1();
	this.instance.parent = this;
	this.instance.setTransform(30.1,18.9,0.303,0.303,-155.3,0,0,11,10.9);
	this.instance.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_1 = new lib.M_Wash_Bubble_pop_1();
	this.instance_1.parent = this;
	this.instance_1.setTransform(30.2,18.9,0.757,0.757,-155.3,0,0,10.9,11);
	this.instance_1.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance}]},38).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:10.9,regY:11,scaleX:0.76,scaleY:0.76,x:30.2},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_2 = new lib.M_Wash_Bubble_1();
	this.instance_2.parent = this;
	this.instance_2.setTransform(24.5,20.9,0.313,0.313,-155.3,0,0,11.1,11.1);
	this.instance_2.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_3 = new lib.M_Wash_Bubble_pop_1();
	this.instance_3.parent = this;
	this.instance_3.setTransform(24.6,20.9,0.757,0.757,-155.3,0,0,11,11);
	this.instance_3.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_2}]}).to({state:[{t:this.instance_2}]},40).to({state:[{t:this.instance_3}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_2).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76,x:24.6},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_4 = new lib.M_Wash_Bubble_1();
	this.instance_4.parent = this;
	this.instance_4.setTransform(39.6,16.1,0.287,0.287,-155.3,0,0,10.8,10.8);
	this.instance_4.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_5 = new lib.M_Wash_Bubble_pop_1();
	this.instance_5.parent = this;
	this.instance_5.setTransform(39.6,16.1,0.757,0.757,-155.3,0,0,11,11);
	this.instance_5.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_4}]}).to({state:[{t:this.instance_4}]},34).to({state:[{t:this.instance_5}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_4).to({regX:11,regY:11,scaleX:0.76,scaleY:0.76},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_6 = new lib.M_Wash_Bubble_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(9.9,-2.5,0.199,0.199,-155.3,0,0,11,10.7);
	this.instance_6.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_7 = new lib.M_Wash_Bubble_pop_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(9.8,-2.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_7.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_7}]},32).to({state:[{t:this.instance_7}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:9.8},32).wait(60));

	// M_Wash_Bubble
	this.instance_8 = new lib.M_Wash_Bubble_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(25.7,-1.5,0.162,0.162,-155.3,0,0,11.2,11.2);
	this.instance_8.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_9 = new lib.M_Wash_Bubble_pop_1();
	this.instance_9.parent = this;
	this.instance_9.setTransform(25.6,-1.5,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_9.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_8}]}).to({state:[{t:this.instance_9}]},36).to({state:[{t:this.instance_9}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_8).to({_off:true,regX:11.1,regY:11,scaleX:0.76,scaleY:0.76,x:25.6},36).wait(56));

	// M_Wash_Bubble
	this.instance_10 = new lib.M_Wash_Bubble_1();
	this.instance_10.parent = this;
	this.instance_10.setTransform(22.2,6,0.108,0.108,-155.3,0,0,11.1,11.8);
	this.instance_10.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_11 = new lib.M_Wash_Bubble_pop_1();
	this.instance_11.parent = this;
	this.instance_11.setTransform(22,6,0.757,0.757,-155.3,0,0,11.2,10.9);
	this.instance_11.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_10}]}).to({state:[{t:this.instance_11}]},30).to({state:[{t:this.instance_11}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_10).to({_off:true,regX:11.2,regY:10.9,scaleX:0.76,scaleY:0.76,x:22},30).wait(62));

	// M_Wash_Bubble
	this.instance_12 = new lib.M_Wash_Bubble_1();
	this.instance_12.parent = this;
	this.instance_12.setTransform(29.2,-9,0.119,0.119,-155.3,0,0,11.5,11);
	this.instance_12.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_13 = new lib.M_Wash_Bubble_pop_1();
	this.instance_13.parent = this;
	this.instance_13.setTransform(29.1,-9,0.757,0.757,-155.3,0,0,11.1,11);
	this.instance_13.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_12}]}).to({state:[{t:this.instance_13}]},32).to({state:[{t:this.instance_13}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_12).to({_off:true,regX:11.1,scaleX:0.76,scaleY:0.76,x:29.1},32).wait(60));

	// M_Wash_Bubble
	this.instance_14 = new lib.M_Wash_Bubble_1();
	this.instance_14.parent = this;
	this.instance_14.setTransform(42.2,-3.1,0.271,0.271,-155.3,0,0,10.3,11.3);
	this.instance_14.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_15 = new lib.M_Wash_Bubble_pop_1();
	this.instance_15.parent = this;
	this.instance_15.setTransform(42.2,-3.1,0.757,0.757,-155.3,0,0,11,11.1);
	this.instance_15.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_14}]}).to({state:[{t:this.instance_15}]},30).to({state:[{t:this.instance_15}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_14).to({_off:true,regX:11,regY:11.1,scaleX:0.76,scaleY:0.76},30).wait(62));

	// M_Wash_Bubble
	this.instance_16 = new lib.M_Wash_Bubble_1();
	this.instance_16.parent = this;
	this.instance_16.setTransform(48.3,9,0.125,0.125,-155.3,0,0,11,10.5);
	this.instance_16.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_16).to({regY:11,scaleX:0.76,scaleY:0.76,x:48.4,y:8.9},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_17 = new lib.M_Wash_Bubble_1();
	this.instance_17.parent = this;
	this.instance_17.setTransform(32.6,-16.6,0.076,0.076,-155.3,0,0,10.8,11);
	this.instance_17.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_17).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,y:-16.7},20).wait(2).to({_off:true},2).wait(68));

	// M_Wash_Bubble
	this.instance_18 = new lib.M_Wash_Bubble_1();
	this.instance_18.parent = this;
	this.instance_18.setTransform(35.5,5.1,0.103,0.103,-155.3,0,0,10.3,10.8);
	this.instance_18.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_18).to({regX:11,regY:11.1,scaleX:0.76,scaleY:0.76,x:32.6,y:7.6},22).wait(2).to({regY:11,x:35.5,y:5.1},0).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_19 = new lib.M_Wash_Bubble_1();
	this.instance_19.parent = this;
	this.instance_19.setTransform(56,0.3,0.124,0.124,-155.3,0,0,10.5,11.2);
	this.instance_19.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_20 = new lib.M_Wash_Bubble_pop_1();
	this.instance_20.parent = this;
	this.instance_20.setTransform(52,-4.5,0.686,0.686,-155.4,0,0,10.3,11.2);
	this.instance_20.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_19}]}).to({state:[{t:this.instance_19}]},24).to({state:[{t:this.instance_20}]},2).to({state:[]},2).wait(64));
	this.timeline.addTween(cjs.Tween.get(this.instance_19).to({regX:10.3,scaleX:0.69,scaleY:0.69,rotation:-155.4,x:52,y:-4.5},24).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_21 = new lib.M_Wash_Bubble_1();
	this.instance_21.parent = this;
	this.instance_21.setTransform(52.4,20,0.067,0.067,-155.3,0,0,11.8,11.1);
	this.instance_21.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_22 = new lib.M_Wash_Bubble_pop_1();
	this.instance_22.parent = this;
	this.instance_22.setTransform(52.4,19.8,0.757,0.757,-155.3,0,0,11.2,11.2);
	this.instance_22.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_21}]}).to({state:[{t:this.instance_21}]},22).to({state:[{t:this.instance_22}]},8).to({state:[{t:this.instance_22}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_21).to({regX:11.7,regY:11.2,scaleX:0.53,scaleY:0.53,rotation:-155.4,x:46.9,y:21.6},22).to({_off:true,regX:11.2,scaleX:0.76,scaleY:0.76,rotation:-155.3,x:52.4,y:19.8},8).wait(62));

	// M_Wash_Bubble
	this.instance_23 = new lib.M_Wash_Bubble_1();
	this.instance_23.parent = this;
	this.instance_23.setTransform(38.5,-8.5,0.4,0.4,0,0,0,11,11);
	this.instance_23.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_24 = new lib.M_Wash_Bubble_pop_1();
	this.instance_24.parent = this;
	this.instance_24.setTransform(38.5,-8.5,1,1,0,0,0,11,11);
	this.instance_24.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_23}]}).to({state:[{t:this.instance_23}]},38).to({state:[{t:this.instance_24}]},2).to({state:[]},2).wait(50));
	this.timeline.addTween(cjs.Tween.get(this.instance_23).to({scaleX:1,scaleY:1},38).to({_off:true},2).wait(52));

	// M_Wash_Bubble
	this.instance_25 = new lib.M_Wash_Bubble_1();
	this.instance_25.parent = this;
	this.instance_25.setTransform(44,-14,0.413,0.413,0,0,0,11,11);
	this.instance_25.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_26 = new lib.M_Wash_Bubble_pop_1();
	this.instance_26.parent = this;
	this.instance_26.setTransform(44,-14,1,1,0,0,0,11,11);
	this.instance_26.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_25}]}).to({state:[{t:this.instance_25}]},40).to({state:[{t:this.instance_26}]},2).to({state:[]},2).wait(48));
	this.timeline.addTween(cjs.Tween.get(this.instance_25).to({scaleX:1,scaleY:1},40).to({_off:true},2).wait(50));

	// M_Wash_Bubble
	this.instance_27 = new lib.M_Wash_Bubble_1();
	this.instance_27.parent = this;
	this.instance_27.setTransform(28.7,0,0.379,0.379,0,0,0,11,11);
	this.instance_27.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_28 = new lib.M_Wash_Bubble_pop_1();
	this.instance_28.parent = this;
	this.instance_28.setTransform(28.7,0,1,1,0,0,0,11,11);
	this.instance_28.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_27}]}).to({state:[{t:this.instance_27}]},34).to({state:[{t:this.instance_28}]},2).to({state:[]},2).wait(54));
	this.timeline.addTween(cjs.Tween.get(this.instance_27).to({scaleX:1,scaleY:1},34).to({_off:true},2).wait(56));

	// M_Wash_Bubble
	this.instance_29 = new lib.M_Wash_Bubble_1();
	this.instance_29.parent = this;
	this.instance_29.setTransform(74.5,6,0.263,0.263,0,0,0,11,11);
	this.instance_29.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_30 = new lib.M_Wash_Bubble_pop_1();
	this.instance_30.parent = this;
	this.instance_30.setTransform(74.5,6,1,1,0,0,0,11,11);
	this.instance_30.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_29}]}).to({state:[{t:this.instance_30}]},32).to({state:[{t:this.instance_30}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_29).to({_off:true,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_31 = new lib.M_Wash_Bubble_1();
	this.instance_31.parent = this;
	this.instance_31.setTransform(54.9,13.5,0.214,0.214,0,0,0,11,11.2);
	this.instance_31.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_32 = new lib.M_Wash_Bubble_pop_1();
	this.instance_32.parent = this;
	this.instance_32.setTransform(54.9,13.5,1,1,0,0,0,11,11);
	this.instance_32.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_31}]}).to({state:[{t:this.instance_32}]},36).to({state:[{t:this.instance_32}]},2).to({state:[]},2).wait(52));
	this.timeline.addTween(cjs.Tween.get(this.instance_31).to({_off:true,regY:11,scaleX:1,scaleY:1},36).wait(56));

	// M_Wash_Bubble
	this.instance_33 = new lib.M_Wash_Bubble_1();
	this.instance_33.parent = this;
	this.instance_33.setTransform(55,2.5,0.143,0.143,0,0,0,10.8,11.2);
	this.instance_33.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_34 = new lib.M_Wash_Bubble_pop_1();
	this.instance_34.parent = this;
	this.instance_34.setTransform(55,2.5,1,1,0,0,0,11,11);
	this.instance_34.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_33}]}).to({state:[{t:this.instance_34}]},30).to({state:[{t:this.instance_34}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_33).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_35 = new lib.M_Wash_Bubble_1();
	this.instance_35.parent = this;
	this.instance_35.setTransform(54.9,24.5,0.157,0.157,0,0,0,11.2,11.2);
	this.instance_35.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_36 = new lib.M_Wash_Bubble_pop_1();
	this.instance_36.parent = this;
	this.instance_36.setTransform(54.9,24.5,1,1,0,0,0,11,11);
	this.instance_36.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_35}]}).to({state:[{t:this.instance_36}]},32).to({state:[{t:this.instance_36}]},2).to({state:[]},2).wait(56));
	this.timeline.addTween(cjs.Tween.get(this.instance_35).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},32).wait(60));

	// M_Wash_Bubble
	this.instance_37 = new lib.M_Wash_Bubble_1();
	this.instance_37.parent = this;
	this.instance_37.setTransform(36,24.5,0.357,0.357,0,0,0,10.2,11.1);
	this.instance_37.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_38 = new lib.M_Wash_Bubble_pop_1();
	this.instance_38.parent = this;
	this.instance_38.setTransform(36,24.5,1,1,0,0,0,11,11);
	this.instance_38.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_37}]}).to({state:[{t:this.instance_38}]},30).to({state:[{t:this.instance_38}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_37).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

	// M_Wash_Bubble
	this.instance_39 = new lib.M_Wash_Bubble_1();
	this.instance_39.parent = this;
	this.instance_39.setTransform(22,13.5,0.165,0.165,0,0,0,10.9,11);
	this.instance_39.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_39).to({regY:10.9,scaleX:0.91,scaleY:0.91,x:18.6,y:13.3},22).to({regX:11,regY:11,scaleX:1,scaleY:1,x:22,y:13.5},2).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_40 = new lib.M_Wash_Bubble_1();
	this.instance_40.parent = this;
	this.instance_40.setTransform(39.7,11,0.136,0.136,0,0,0,11.1,11.1);
	this.instance_40.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_40).to({regX:11,regY:11,scaleX:1,scaleY:1},22).wait(2).to({_off:true},2).wait(66));

	// M_Wash_Bubble
	this.instance_41 = new lib.M_Wash_Bubble_1();
	this.instance_41.parent = this;
	this.instance_41.setTransform(17.7,28,0.164,0.164,0,0,0,10.7,11);
	this.instance_41.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get(this.instance_41).to({regX:11,scaleX:1,scaleY:1},24).wait(2).to({_off:true},2).wait(64));

	// M_Wash_Bubble
	this.instance_42 = new lib.M_Wash_Bubble_1();
	this.instance_42.parent = this;
	this.instance_42.setTransform(11,2.5,0.088,0.088,0,0,0,10.8,10.8);
	this.instance_42.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.instance_43 = new lib.M_Wash_Bubble_pop_1();
	this.instance_43.parent = this;
	this.instance_43.setTransform(11,2.5,1,1,0,0,0,11,11);
	this.instance_43.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,1,6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_42}]}).to({state:[{t:this.instance_43}]},30).to({state:[{t:this.instance_43}]},2).to({state:[]},2).wait(58));
	this.timeline.addTween(cjs.Tween.get(this.instance_42).to({_off:true,regX:11,regY:11,scaleX:1,scaleY:1},30).wait(62));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-11.2,-37.9,114.4,94.8);


(lib.PolarBearTorso_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":85});

	// Layer 5
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-49,-84,1.17,1.225,0,116,118.3,35.8,10.9);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(97,-58.5,1.17,1.225,0,179.5,-178.2,35.9,9.2);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(51.2,-59.4,1.17,1.225,0,179.5,-178.2,30.2,11.3);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(1.8,-78.3,1.17,1.225,0,131,133.3,35.9,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},84).wait(58));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.PolarBearTorso = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":86,"glowclean":87,"glowclean_loop":88,"final":89,"final_loop":90});

	// Polar Bear Torso0002.png copy
	this.instance = new lib.PolarBearTorso0002();
	this.instance.parent = this;
	this.instance.setTransform(-167.6,-99.3,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-31.6,-82.3,1,1,0,0,0,47.6,10.1);

	this.instance_2 = new lib.left_over_bubbles_few();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-6.5,-68.6,1,1,0,0,0,47.8,9.3);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(50.6,-54.1,1,1,0,0,0,50.6,5.2);

	this.instance_4 = new lib.PolarBearTorso0001();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-167.6,-99.3,0.5,0.5);

	this.instance_5 = new lib.polarbear_backGlow();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-15.8,-42.7,2,2,0,-6,174,85.4,29.7);

	this.glow = new lib.blueglowback();
	this.glow.parent = this;
	this.glow.setTransform(-15.8,-42.7,2,2,0,-6,174,85.4,29.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance,p:{x:-167.6,y:-99.3}}]}).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance,p:{x:-168,y:-99}},{t:this.instance_5}]},2).to({state:[{t:this.instance_4}]},2).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},34).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},46).to({state:[{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_4}]},2).to({state:[]},2).wait(124));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-167.6,-103.4,340,214.2);


(lib.PolarBearHindLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":80});

	// Layer 6
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-57.4,17.5,1.118,1.118,-24.2,0,0,35.6,10.9);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(148.7,3.8,1.118,1.118,140.5,0,0,35.6,10.9);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-27.2,27.6,1.118,1.118,173.8,0,0,35.2,11);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(77.4,-9,1.118,1.118,23.8,0,0,35.5,11.1);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-43.7,-29.6,1.118,1.118,-135.5,0,0,35.8,11.1);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-148.3,25.3,1,1,-146.8,0,0,35.6,11);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(50.8,26.3,1,1,134.3,0,0,35.6,10.8);

	this.instance_7 = new lib.Bubbles_together();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-12.4,-2,1,1,0,0,0,35.6,11.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},79).wait(164));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.PolarBearFrontLeg_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":60});

	// Layer 3
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(-207.7,64.9,0.624,0.699,0,-110.2,-114.9,35.5,10.7);

	this.instance_1 = new lib.Bubbles_together();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-162.7,73.8,0.624,0.699,0,-110.2,-114.9,35.5,10.7);

	this.instance_2 = new lib.Bubbles_together();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-116.8,79.6,0.624,0.699,0,-105.7,-110.4,35.4,11.1);

	this.instance_3 = new lib.Bubbles_together();
	this.instance_3.parent = this;
	this.instance_3.setTransform(56.6,58.5,0.624,0.699,0,-58.5,-63.2,35.6,10.7);

	this.instance_4 = new lib.Bubbles_together();
	this.instance_4.parent = this;
	this.instance_4.setTransform(82.1,63.7,0.624,0.699,0,-10.5,-15.2,35.6,10.8);

	this.instance_5 = new lib.Bubbles_together();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-17.6,78.1,0.624,0.699,0,-85.2,-89.9,35.5,10.3);

	this.instance_6 = new lib.Bubbles_together();
	this.instance_6.parent = this;
	this.instance_6.setTransform(17.5,78.1,0.624,0.699,0,-10.5,-15.2,35.6,10.8);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[]}).to({state:[{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},1).to({state:[]},59).wait(94));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.PolarBearHead_bubbles = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"wash":0,"wash_stop":49});

	// Snout
	this.instance = new lib.Bubbles_together();
	this.instance.parent = this;
	this.instance.setTransform(5.6,11.8,0.803,0.765,0,-7.3,-5.3,35.6,11.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},48).wait(96));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;


(lib.PolarBearHead = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":60,"glowclean":61,"glowclean_loop":62,"final":63,"final_loop":64});

	// polarbear_excited_head_003.png
	this.instance = new lib.PolarBearHead0001();
	this.instance.parent = this;
	this.instance.setTransform(-58.8,-50,0.5,0.5);

	this.instance_1 = new lib.polarbear_excited_head_003();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-58.8,-50,0.5,0.5);

	this.instance_2 = new lib.polarbear_noseGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(12.5,9.9,1.25,1.25,0,0,180,16.2,18.1);

	this.glow = new lib.blueglownose();
	this.glow.parent = this;
	this.glow.setTransform(12.5,9.9,1.25,1.25,0,0,180,16.2,18.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance,p:{x:-58.8}}]}).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance,p:{x:-59}},{t:this.instance_2}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance_1}]},54).to({state:[{t:this.instance_1},{t:this.glow}]},1).to({state:[{t:this.instance_1}]},2).to({state:[]},2).wait(150));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-58.8,-50,123,107);


(lib.water_drops_014 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// Layer 2
	this.instance = new lib.Running_drop();
	this.instance.parent = this;
	this.instance.setTransform(185.8,10.7,0.486,0.486,0,0,180,4.8,10.1);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// Layer 1
	this.instance_1 = new lib.Running_drop();
	this.instance_1.parent = this;
	this.instance_1.setTransform(174.5,47.7,0.486,0.486,0,0,180,4.7,10.1);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(7).to({_off:false},0).to({_off:true},24).wait(2));

	// WET DROPS
	this.instance_2 = new lib.Running_drop();
	this.instance_2.parent = this;
	this.instance_2.setTransform(70,37,0.486,0.486,0,0,180,4.8,10.1);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(4).to({_off:false},0).to({_off:true},24).wait(5));

	// WET DROPS
	this.instance_3 = new lib.Running_drop();
	this.instance_3.parent = this;
	this.instance_3.setTransform(20,71.3,0.486,0.486,0,0,180,4.7,10.1);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1).to({_off:false},0).to({_off:true},24).wait(8));

	// WET DROPS
	this.instance_4 = new lib.Running_drop();
	this.instance_4.parent = this;
	this.instance_4.setTransform(42.4,57.4,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(6).to({_off:false},0).to({_off:true},24).wait(3));

	// WET DROPS
	this.instance_5 = new lib.Running_drop();
	this.instance_5.parent = this;
	this.instance_5.setTransform(214.7,42.7,0.486,0.486,0,0,0,4.8,10.1);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(3).to({_off:false},0).to({_off:true},24).wait(6));

	// WET DROPS
	this.instance_6 = new lib.Running_drop();
	this.instance_6.parent = this;
	this.instance_6.setTransform(132.4,67.1,0.486,0.486,0,0,0,4.8,10.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_6).to({_off:true},24).wait(9));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(125.1,57.2,18,23);


(lib.polarbear_pawMud_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"glowclean":210,"glowclean_loop":211,"final":212,"final_loop":213});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AigC7QghgYgogKIgDgDQgRgHgGgMIgOgJIAAAAIgNAHQgLgMgJgHIgCAAIgFgCIAAgCQgCgGABgKQABgEgFACIAAACQgGgCAAAHIgBACIgPAJIgNgHIgEgGIACgXIgHAHIgIACIAEgCIgEABIAAgEIgBgIIAAgDQABgQAJgJQAQgOAtgEQgDgPADgJQADgPAPgEQgNgeAAgQQAAg/BAAmIgDgdQAAg+AegIQAYgHAoAeQAjAbAdAnIAOAVQAFgOAJgFQAPgIAZAUQAVASASAeIADAFIABgEQAGgOAHgIQgMgIgKgPQgPgXAAgOQAAg2AtAiIADADQAbBEAbA+IACAAIgBAHIAGAGIAAAEIACACIACADIAEAJQAqAJAuAJIAHAEQATAAAPAFQACACAEAAQAVAJAUAGQAHADAJAAIAEAEIALABQAFADAGABIARAQIAPAIIALADQAGAMAAANIgBAHIABAJQAAAdgyAWQgMgEgOAAQhPABhOAHQg7AJg9AAIgkACQhWAAhQgYgAmGAAQgEgGAAgPQAAgYARgJIgEgEQgFgHAAgGQAAgWAYgCQAXgBAAAYIgDAMIgCADQAUAGAAAfIgBAQQgHANgbAAQgXAAgIgJgAgpisQgFgHAAgHQAAgYAXAAQAXABAAAXQAAAGgDAGQgGALgOAAQgLAAgHgJg");
	this.shape.setTransform(39.5,21.1);

	this.instance = new lib.left_over_bubbles_sparse();
	this.instance.parent = this;
	this.instance.setTransform(49.9,28.4,1,1,0,0,0,47.6,10.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance}]},54).to({state:[]},150).to({state:[]},2).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,79.1,42.1);


(lib.polarbear_pawMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":111,"glowclean":112,"glowclean_loop":113,"final":114,"final_loop":115});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AAsCEQieggiXgSQgqgJgOgRQgPgRAAgqQABgKAFgJQAJgTAPAAIAFABQgGgPAAgGQAAgGACgGQADgLAMAAQASAAAkASQAUAKAJAHQAPABAMAGQAJAFAMAJQAAgTASAAQAiAAAtASQAFgGABgMIACgUQAHgYArgHIAEAAIADgMQAHgVAOAAQAQAAAOAQIADAFIAGAFQAFAFADAIQAnAGAgAQQALAGARABQANACAGAGQATARAMADQBeAYAIACIAGALIAHgCIgCAKIgHgIIgIgCIg0gCQgJACgIAHIgFAGIgGACIgDAKIACAEIADAJQgRgFgcAAIgVANIgCAaIADANIARANQgBALAEAIQgnAIg2AHgAAjhiIgBAAIAAAAIABAAIAAAAgAFQAAIABAAIgCAAg");
	this.shape.setTransform(33.7,13.2);

	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(52.1,15.7,1,1,0,0,0,47.8,9.3);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(35.5,11.1,1,1,-6.7,0,0,46.7,10.5);

	this.instance_2 = new lib.polarbear_footGlow();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-32.7,5.7,1.5,1.5,0,0,180,71,3.1);

	this.glow = new lib.blueglowpaws();
	this.glow.parent = this;
	this.glow.setTransform(-32.7,5.7,1.5,1.5,0,0,180,71,3.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape},{t:this.instance_2}]},2).to({state:[]},2).to({state:[{t:this.instance_1},{t:this.instance}]},8).to({state:[{t:this.instance_1},{t:this.instance}]},97).to({state:[{t:this.instance_1},{t:this.instance},{t:this.glow}]},1).to({state:[]},2).wait(101));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,67.5,26.4);


(lib.polarbear_legMud_004 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"glowclean":210,"glowclean_loop":211,"final":212,"final_loop":213});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("ApHHbQACgmgCgjQgFhCgSg5QgdhVgZhyQgahxBBjDQBAjDCUA6QBEjqBeCOQBeCOBfiNQB8jBB7CDQCjCwB5g3QB5g3AIBAQAIA/AOAlQAOAlAAAUQAeA2AAAuQgBA2gJA1QhGgdhbA0IAAAFQABALgOAEQgDgBgDACQgCADgDACQhUA0hjABIgHgDIgbACIAiABIAEABQAuAWAWArIgdAcIgQABQhIANgwgbQhagBg2AqIANAUIAzATQgCANgKAGQgnAYgxAFIgdARIgOARIgoASIgrADQAKAIAJAEQAXAGAGAQQgIAHgIABQhUAZhWA6Qh3AQh9AEIAuASIgBAgQgDADgDABQgxALg0AUQghgbADhGg");
	this.shape.setTransform(68.4,72.7);

	this.instance = new lib.left_over_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(43.8,26.7,1,1,0,0,0,50.6,5.2);

	this.instance_1 = new lib.left_over_bubbles("synched",0,false);
	this.instance_1.parent = this;
	this.instance_1.setTransform(53.4,73.4,1.01,1.01,-90,0,0,35.8,10.7);

	this.instance_2 = new lib.left_over_bubbles_sparse("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(29.5,32.2,1.01,1.01,125.3,0,0,35.6,11);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance_2},{t:this.instance_1},{t:this.instance}]},54).to({state:[]},150).to({state:[]},2).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(1.6,15.5,133.6,114.4);


(lib.polarbear_legMud_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":120,"glowclean":121,"glowclean_loop":122,"final":123,"final_loop":124});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("ABHH0QgvhEgIAAQgMAAgdAJQgeAKgNAAQguAAhRgzQg/gogLgEQgGgDgMgCIggAAIitgIQhVgFAFhtQACgmgCgjQgEhCgTg4QgdhVgZhyQgZhyBAjDIAJgZQAbABAXAEIAKAJIAYAHIAYgIIgNgiIAYgEQAzAEAxAUIBLgLIAKgQIAggGQAFAGAIAEQAkAPAxgHIAFAGIAEADIAdAJIAKgCQAbgCAKgMIABglIAhgCQAFAIAHAGQAkAeA2AUIgXgcIgCgWIArAHIAkAoIALAHQAKAJAOgBQAIADADgJIAWhJIAYgLIAHAYQAVA+AsAiIAIADQAbAIAYAPIALgCQAkgGAhAOQAHAJALAIQBvBRBdBgIAQAEIAIAHQgRBIgbAoQgDAngGAUQgGASgUAXQgxA4gbCdQgEAdhHA1QhPA7gRAeQgFA3gTAqQgkBThgAAQgxAAg3hDgAmXHAQAKg5AvAoQCbgzhhBYQgUAEg1AQQgMAEgJAAQgeAAAJgsg");
	this.shape.setTransform(67.2,97.3);

	this.instance = new lib.left_over_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(97,92.2,1,1,0,0,0,50.6,5.2);

	this.instance_1 = new lib.left_over_bubbles("synched",0,false);
	this.instance_1.parent = this;
	this.instance_1.setTransform(106.6,138.9,1.01,1.01,-90,0,0,35.8,10.7);

	this.instance_2 = new lib.left_over_bubbles_sparse("synched",0,false);
	this.instance_2.parent = this;
	this.instance_2.setTransform(82.5,97.8,1.01,1.01,125.3,0,0,35.8,11);

	this.instance_3 = new lib.polarbear_legGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(59.6,-21.3,2.098,2.098,0,75.2,-104.8,6.4,66.5);

	this.glow = new lib.legsglowblue();
	this.glow.parent = this;
	this.glow.setTransform(59.6,-21.3,2.098,2.098,0,75.2,-104.8,6.4,66.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_2,p:{y:97.8}},{t:this.instance_1,p:{y:138.9}},{t:this.instance,p:{y:92.2}}]},2).to({state:[{t:this.shape},{t:this.instance_3}]},2).to({state:[]},2).to({state:[{t:this.instance_2,p:{y:97.8}},{t:this.instance_1,p:{y:138.9}},{t:this.instance,p:{y:92.2}}]},34).to({state:[{t:this.instance_2,p:{y:97.8}},{t:this.instance_1,p:{y:138.9}},{t:this.instance,p:{y:92.2}}]},80).to({state:[{t:this.instance_2,p:{y:55.5}},{t:this.instance_1,p:{y:96.6}},{t:this.instance,p:{y:49.9}},{t:this.glow}]},1).to({state:[]},2).wait(92));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(1.6,40.6,131.4,113.4);


(lib.PolarBearHead_003 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// bubbles
	this.instance = new lib.PolarBearHead_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(24.1,12.8,1,1,0,0,180);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).wait(79).to({x:20.7,y:13.6},0).to({_off:true},70).wait(55));

	// Layer 6
	this.instance_1 = new lib.PolarBearHead_0030001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-47.9,-54.7,0.5,0.5);

	this.instance_2 = new lib.PolarBearHead_excited_roar_001();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-47.9,-54.7,0.5,0.5);

	this.instance_3 = new lib.polarbear_noseGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(44,7.1,1.25,1.25,0,-30,150,16.3,18.1);

	this.glow = new lib.bluenoseglow3();
	this.glow.parent = this;
	this.glow.setTransform(44,7.1,1.25,1.25,0,-30,150,16.3,18.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1}]}).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_1},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2}]},79).to({state:[{t:this.instance_2},{t:this.glow}]},71).to({state:[{t:this.instance_2}]},2).to({state:[]},2).to({state:[]},1).wait(49));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-47.9,-54.7,133,111);


(lib.PolarBearHead_002 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// bubbles
	this.instance = new lib.PolarBearHead_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(24.1,12.8,1,1,0,0,180);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(6).to({_off:false},0).wait(79).to({x:20.7,y:13.6},0).to({_off:true},70).wait(55));

	// Layer 2
	this.instance_1 = new lib.PolarBearHead_0020002();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-48.5,-50.1,0.5,0.5);

	this.instance_2 = new lib.PolarBearHead_excited_roar_002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-48.5,-50.1,0.5,0.5);

	this.instance_3 = new lib.polarbear_noseGlow();
	this.instance_3.parent = this;
	this.instance_3.setTransform(28.2,8.9,1.25,1.25,0,0,180,16.2,18.1);

	this.glow = new lib.bluenoseglow2();
	this.glow.parent = this;
	this.glow.setTransform(28.2,8.9,1.25,1.25,0,0,180,16.2,18.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_1,p:{x:-48.5,y:-50.1}}]}).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_1,p:{x:-49,y:-50}},{t:this.instance_3}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_2},{t:this.glow}]},150).to({state:[{t:this.instance_2}]},2).to({state:[]},2).to({state:[]},1).wait(49));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-48.5,-51,111,107.9);


(lib.pawmud2 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"glowclean":210,"glowclean_loop":211,"final":212,"final_loop":213});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AjAB8QgMgDgJgEIgHgKQgGgDgGgGIgIgIIgIgGIgRgCQgqgJgOgRQgPgSAAgpQABgKAFgKQAJgSAPAAIAFAAQgGgOAAgGQAAgGACgGQADgLAMAAQASAAAkASQAUAKAJAGQAPABAMAHQAJAFAMAJQAAgTASAAQAiAAAtASQAFgHABgMIACgUQAHgXArgHIAEAAIADgNQAHgUAOAAQAQAAAOAQIADAFIAGAFQAFAFADAHQAhAGAbAMQAyACAwAGQAMADAIAEIAHAKQAHADAGAGIAIAIQAHAEAFAHQAAAAABABQAAABAAAAQAAABAAAAQAAABAAABIAgAIIAGALIAHgCIABgBIABABIgCAAIgCAKIgHgIIgIgDIg0gCQgJADgIAHIgFAFIgGACIgDAKIACAFIADAJQgRgGgcAAIgVAOIgCAaIADAMIARAOQgBAKAEAJQgnAIg2AHIg6AAIgngIIgGADIgCACIgKAAIgUAAIgMgEIgCAAIAKAGIgjABQg9AAg7gIgAAihiIABAAIgBAAg");
	this.shape.setTransform(33.7,13.2);

	this.instance = new lib.left_over_bubbles_few();
	this.instance.parent = this;
	this.instance.setTransform(52.1,15.7,1,1,0,0,0,47.8,9.3);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(35.5,11.1,1,1,-6.7,0,0,46.7,10.5);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(169,114,78,0.8)").s().p("AjAB8QgMgDgJgEIgHgKQgGgDgGgGIgIgIIgIgGIgRgCQgqgJgOgRQgPgSAAgpQABgKAFgKQAJgSAPAAIAFAAQgGgOAAgGQAAgGACgGQADgLAMAAQASAAAkASQAUAKAJAGQAPABAMAHQAJAFAMAJQAAgTASAAQAiAAAtASQAFgHABgMIACgUQAHgXArgHIAEAAIADgNQAHgUAOAAQAQAAAOAQIADAFIAGAFQAFAFADAHQAhAGAbAMQAyACAwAGQAMADAIAEIAHAKQAHADAGAGIAIAIQAHAEAFAHQAAAAABABQAAABAAAAQAAABAAAAQAAABAAABIAgAIIAGALIAHgCIgCAKIgHgIIgIgDIg0gCQgJADgIAHIgFAFIgGACIgDAKIACAFIADAJQgRgGgcAAIgVAOIgCAaIADAMIARAOQgBAKAEAJQgnAIg2AHIg6AAIgngIIgGADIgCACIgKAAIgUAAIgMgEIgCAAIAKAGIgjABQg9AAg7gIgAAjhiIgBAAIAAAAIABAAIAAAAgAFQgBIABABIgCAAg");
	this.shape_1.setTransform(33.7,13.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance_1},{t:this.instance}]},2).to({state:[{t:this.shape_1}]},2).to({state:[]},2).to({state:[{t:this.instance_1},{t:this.instance}]},13).to({state:[]},191).to({state:[]},2).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,67.5,26.4);


(lib.legmudback = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"glowclean":210,"glowclean_loop":211,"final":212,"final_loop":213});

	// Layer 1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("rgba(169,114,78,0.8)").s().p("AhbCDQgKgEgBgJQh6gtiIgSQgRgBgJgMQhDgQhGgLQBCjXBcCJQBeCNBfiLQB9jCB6CEQCkCuB4g2QB5g2AIA+QAIBAAOAlQAOAkAAAUIAEAHIgGgBQgNgDAAAJQg+gFg3ADQgIADgKgDQhPAEhQgEIgHAFQiWgMiRgig");
	this.shape.setTransform(80.2,33.2);

	this.instance = new lib.left_over_bubbles();
	this.instance.parent = this;
	this.instance.setTransform(71.2,26.7,1,1,15,0,0,50.7,5.2);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.shape}]},2).to({state:[]},2).to({state:[{t:this.instance}]},54).to({state:[]},150).to({state:[]},2).wait(2));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(27.8,15.5,104.8,35.5);


(lib.PolarBearHindLegBack = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159,"final":160,"final_loop":161});

	// Polar Bear Hind Leg Back0001.png copy
	this.pawmud = new lib.polarbear_pawMud_004();
	this.pawmud.parent = this;
	this.pawmud.setTransform(15.1,100.6,1,1,0,0,0,34.2,13.2);

	this.legmud = new lib.polarbear_legMud_004();
	this.legmud.parent = this;
	this.legmud.setTransform(-32.1,46.6,0.4,0.4,97.7,0,0,68.9,85);

	this.instance = new lib.PolarBearHindLegBack0004();
	this.instance.parent = this;
	this.instance.setTransform(-49.5,-111.5,0.5,0.5);

	this.instance_1 = new lib.PolarBearHindLegBack0001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-49.5,-111.5,0.5,0.5);

	this.instance_2 = new lib.PolarBearHindLegBack0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-49.5,-111.5,0.5,0.5);

	this.instance_3 = new lib.PolarBearHindLegBack0003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-49.5,-111.5,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.legmud},{t:this.pawmud}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[]},146).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-59.9,-111.5,157.6,245.7);


(lib.PolarBearHindLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159});

	// Polar Bear Hind Leg0002.png copy
	this.pawmud = new lib.pawmud2();
	this.pawmud.parent = this;
	this.pawmud.setTransform(18.6,93.8,1,1,0,0,0,33.7,13.2);

	this.legmud = new lib.polarbear_legMud_003();
	this.legmud.parent = this;
	this.legmud.setTransform(27.6,8.6,0.75,0.75,0,0,0,68.4,84.8);

	this.instance = new lib.PolarBearHindLeg0004();
	this.instance.parent = this;
	this.instance.setTransform(-68.3,-110.2,0.5,0.5);

	this.instance_1 = new lib.PolarBearHindLeg0001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-68.3,-110.2,0.5,0.5);

	this.instance_2 = new lib.PolarBearHindLeg0002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-68.3,-110.2,0.5,0.5);

	this.instance_3 = new lib.PolarBearHindLeg0003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-68.3,-110.2,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.legmud},{t:this.pawmud}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[]},146).wait(4));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-68.3,-111.2,152.7,239.1);


(lib.PolarBearFrontLegBack_001 = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,"dirty_stop":1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":155,"glowclean":156,"glowclean_loop":157,"final":158,"final_loop":159,"final":160,"final_loop":161});

	// Polar Bear Front Leg Back_0010001.png copy
	this.pawmud = new lib.polarbear_pawMud_002();
	this.pawmud.parent = this;
	this.pawmud.setTransform(16.5,75.9,1,1,0,0,0,39.5,22.9);

	this.legmud = new lib.legmudback();
	this.legmud.parent = this;
	this.legmud.setTransform(39,2.5,0.75,0.75,-95.5,0,0,68.1,72.9);

	this.instance = new lib.PolarBearFrontLegBack_0010004();
	this.instance.parent = this;
	this.instance.setTransform(-56.3,-96.7,0.5,0.5);

	this.instance_1 = new lib.PolarBearFrontLegBack_0010001();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-56.3,-96.7,0.5,0.5);

	this.instance_2 = new lib.PolarBearFrontLegBack_0010002();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-56.3,-96.7,0.5,0.5);

	this.instance_3 = new lib.PolarBearFrontLegBack_0010003();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-56.3,-96.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.legmud},{t:this.pawmud}]}).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_1}]},2).to({state:[{t:this.instance}]},2).to({state:[{t:this.instance_2}]},2).to({state:[{t:this.instance_3}]},2).to({state:[]},146).wait(6));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-56.3,-96.7,154.7,197);


(lib.PolarBearFrontLeg = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{"dirty":0,dirty_loop:1,"clean":2,"clean_loop":3,"glow":4,"glow_loop":5,"wash":6,"wash_stop":209,"glowclean":210,"glowclean_loop":211,"final":212,"final_loop":213});

	// Polar Bear Front Leg0002.png copy
	this.legmud = new lib.polarbear_legMud_001();
	this.legmud.parent = this;
	this.legmud.setTransform(-87,15.2,0.7,0.7,-75);

	this.pawmud = new lib.polarbear_pawMud_001();
	this.pawmud.parent = this;
	this.pawmud.setTransform(4.1,75.7,1,1,0,0,0,34.2,13.2);

	this.instance = new lib.PolarBearFrontLeg0004();
	this.instance.parent = this;
	this.instance.setTransform(-60.1,-90.7,0.5,0.5);

	this.instance_1 = new lib.left_over_bubbles_sparse();
	this.instance_1.parent = this;
	this.instance_1.setTransform(-237.8,10.8,1,1,0,0,0,47.6,10.1);

	this.instance_2 = new lib.left_over_bubbles_few();
	this.instance_2.parent = this;
	this.instance_2.setTransform(-229.9,20.1,1,1,0,0,0,47.8,9.3);

	this.instance_3 = new lib.left_over_bubbles();
	this.instance_3.parent = this;
	this.instance_3.setTransform(-120.3,-5.4,1,1,0,0,0,50.6,5.2);

	this.instance_4 = new lib.left_over_bubbles_sparse();
	this.instance_4.parent = this;
	this.instance_4.setTransform(-107.4,2.1,1,1,0,0,0,47.6,10.1);

	this.instance_5 = new lib.left_over_bubbles_few();
	this.instance_5.parent = this;
	this.instance_5.setTransform(-100.2,-13,1,1,0,0,0,47.8,9.3);

	this.instance_6 = new lib.left_over_bubbles();
	this.instance_6.parent = this;
	this.instance_6.setTransform(-20,-25.1,1,1,-45,0,0,50.6,5.2);

	this.instance_7 = new lib.PolarBearFrontLeg0001();
	this.instance_7.parent = this;
	this.instance_7.setTransform(-60.1,-90.7,0.5,0.5);

	this.instance_8 = new lib.PolarBearFrontLeg0002();
	this.instance_8.parent = this;
	this.instance_8.setTransform(-60.1,-90.7,0.5,0.5);

	this.instance_9 = new lib.PolarBearFrontLeg0003();
	this.instance_9.parent = this;
	this.instance_9.setTransform(-60.1,-90.7,0.5,0.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance},{t:this.pawmud},{t:this.legmud}]}).to({state:[{t:this.instance},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance_7}]},2).to({state:[{t:this.instance},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance_8},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},1).to({state:[{t:this.instance_9},{t:this.instance_6},{t:this.instance_5},{t:this.instance_4},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},2).to({state:[{t:this.instance_7},{t:this.instance_6},{t:this.instance_3},{t:this.instance_2},{t:this.instance_1}]},75).to({state:[]},126).to({state:[]},1).wait(3));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-75.1,-90.7,143.1,191);


(lib.Polar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{wrongAnswer:0,rest:82,rest_stop:186,wet:188,wet_stop:204,"clean":206,clean_stop:222,excited:224,excited_stop:311,animalSound:313});

	// timeline functions:
	this.frame_80 = function() {
		/* gotoAndPlay("rest");*/
	}
	this.frame_186 = function() {
		/* stop();
		
		gameObjects._animal.restTimeout();*/
	}
	this.frame_204 = function() {
		/* stop();*/
	}
	this.frame_222 = function() {
		/* stop();*/
	}
	this.frame_311 = function() {
		/* 
		
		gameObjects._game.done();
		stop();*/
	}
	this.frame_362 = function() {
		/* gotoAndPlay("rest");*/
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(80).call(this.frame_80).wait(106).call(this.frame_186).wait(18).call(this.frame_204).wait(18).call(this.frame_222).wait(89).call(this.frame_311).wait(51).call(this.frame_362).wait(1));

	// Layer 10
	this.instance = new lib.sparkle();
	this.instance.parent = this;
	this.instance.setTransform(296.7,52.4,0.679,0.679);
	this.instance._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(294).to({_off:false},0).to({_off:true},19).wait(50));

	// Layer 9
	this.instance_1 = new lib.sparkle();
	this.instance_1.parent = this;
	this.instance_1.setTransform(261.8,76.6,0.679,0.679);
	this.instance_1._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(290).to({_off:false},0).to({_off:true},23).wait(50));

	// Layer 8
	this.instance_2 = new lib.sparkle();
	this.instance_2.parent = this;
	this.instance_2.setTransform(242.9,38.2,0.679,0.679);
	this.instance_2._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(286).to({_off:false},0).to({_off:true},27).wait(50));

	// Layer 7
	this.instance_3 = new lib.sparkle();
	this.instance_3.parent = this;
	this.instance_3.setTransform(320.7,22.1,0.679,0.679);
	this.instance_3._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(282).to({_off:false},0).to({_off:true},31).wait(50));

	// Layer 6
	this.instance_4 = new lib.sparkle();
	this.instance_4.parent = this;
	this.instance_4.setTransform(268.2,35.6,0.679,0.679);
	this.instance_4._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(278).to({_off:false},0).to({_off:true},35).wait(50));

	// Layer 3
	this.instance_5 = new lib.water_drops_014();
	this.instance_5.parent = this;
	this.instance_5.setTransform(299.8,37.4,0.4,0.4,0,0,180,92.4,49.1);
	this.instance_5._off = true;

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(188).to({_off:false},0).to({_off:true},18).wait(157));

	// leg bubbles
	this.legs_bubbles = new lib.PolarBearHindLeg_bubbles();
	this.legs_bubbles.parent = this;
	this.legs_bubbles.setTransform(291.1,54.2,0.25,0.25,0,4.3,180);

	this.timeline.addTween(cjs.Tween.get(this.legs_bubbles).wait(82).to({_off:true},124).wait(157));

	// Polar Bear Head
	this.nose_bubbles = new lib.PolarBearHead_bubbles();
	this.nose_bubbles.parent = this;
	this.nose_bubbles.setTransform(245.4,32.5,0.28,0.28,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.nose_bubbles).wait(82).to({_off:true},124).wait(157));

	// Polar Bear Front Leg
	this.paws_bubbles = new lib.PolarBearFrontLeg_bubbles();
	this.paws_bubbles.parent = this;
	this.paws_bubbles.setTransform(270.5,58.4,0.25,0.25,0,4.3,180);

	this.timeline.addTween(cjs.Tween.get(this.paws_bubbles).wait(82).to({_off:true},124).wait(157));

	// Polar Bear Torso
	this.back_bubbles = new lib.PolarBearTorso_bubbles();
	this.back_bubbles.parent = this;
	this.back_bubbles.setTransform(292.4,40.3,0.25,0.25,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.back_bubbles).wait(82).to({_off:true},124).wait(157));

	// Polar Bear Head
	this.polar_head = new lib.PolarBearHead();
	this.polar_head.parent = this;
	this.polar_head.setTransform(245.4,32.5,0.28,0.28,0,0,180);

	this.polar_head_1 = new lib.PolarBearHead_002();
	this.polar_head_1.parent = this;
	this.polar_head_1.setTransform(244.3,34.4,0.28,0.28,0,0,180);

	this.polar_head_2 = new lib.PolarBearHead_003();
	this.polar_head_2.parent = this;
	this.polar_head_2.setTransform(241.2,35.5,0.28,0.28,0,0,180);
	this.polar_head_2._off = true;

	this.polar_head_3 = new lib.PolarBearHead_wet_1();
	this.polar_head_3.parent = this;
	this.polar_head_3.setTransform(245.4,32.5,0.28,0.28,0,0,180);

	this.polar_head_4 = new lib.polarbear_excited_head_003_1();
	this.polar_head_4.parent = this;
	this.polar_head_4.setTransform(255.4,34.1,0.28,0.28,0,0,180,-35.5,5.9);

	this.polar_head_5 = new lib.PolarBearHead_excited_roar_002_1();
	this.polar_head_5.parent = this;
	this.polar_head_5.setTransform(244.3,34.4,0.28,0.28,0,0,180);
	this.polar_head_5._off = true;

	this.polar_head_6 = new lib.PolarBearHead_excited_roar_001_1();
	this.polar_head_6.parent = this;
	this.polar_head_6.setTransform(240.9,41.7,0.28,0.28,0,-3.7,176.3);
	this.polar_head_6._off = true;

	this.polar_head_7 = new lib.PolarBearHead_roar_001_1();
	this.polar_head_7.parent = this;
	this.polar_head_7.setTransform(236.3,32.9,0.28,0.28,0,0,180);

	this.polar_head_8 = new lib.PolarBearHead_roar_002_1();
	this.polar_head_8.parent = this;
	this.polar_head_8.setTransform(241.5,28.7,0.28,0.28,0,18.6,-161.4);

	this.polar_head_9 = new lib.PolarBearHead_roar_003_1();
	this.polar_head_9.parent = this;
	this.polar_head_9.setTransform(246.6,24.4,0.28,0.28,0,37.5,-142.5);
	this.polar_head_9._off = true;

	this.polar_head_10 = new lib.PolarBearHead_excited_003();
	this.polar_head_10.parent = this;
	this.polar_head_10.setTransform(245.4,32.5,0.28,0.28,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.polar_head}]}).to({state:[{t:this.polar_head_1,p:{x:244.3,y:34.4}}]},16).to({state:[{t:this.polar_head_2}]},2).to({state:[{t:this.polar_head_2}]},2).to({state:[{t:this.polar_head_2}]},2).to({state:[{t:this.polar_head_2}]},2).to({state:[{t:this.polar_head_2}]},30).to({state:[{t:this.polar_head_2}]},2).to({state:[{t:this.polar_head_2}]},2).to({state:[{t:this.polar_head_2}]},2).to({state:[{t:this.polar_head_1,p:{x:242.7,y:35.2}}]},2).to({state:[{t:this.polar_head}]},2).to({state:[{t:this.polar_head}]},18).to({state:[{t:this.polar_head_1,p:{x:244.3,y:34.4}}]},16).to({state:[{t:this.polar_head_2}]},2).to({state:[{t:this.polar_head_2}]},2).to({state:[{t:this.polar_head_2}]},2).to({state:[{t:this.polar_head_2}]},2).to({state:[{t:this.polar_head_2}]},30).to({state:[{t:this.polar_head_2}]},2).to({state:[{t:this.polar_head_2}]},2).to({state:[{t:this.polar_head_2}]},2).to({state:[{t:this.polar_head_1,p:{x:242.7,y:35.2}}]},2).to({state:[{t:this.polar_head}]},2).to({state:[{t:this.polar_head_3}]},42).to({state:[{t:this.polar_head}]},18).to({state:[{t:this.polar_head_4}]},20).to({state:[{t:this.polar_head_5}]},8).to({state:[{t:this.polar_head_5}]},2).to({state:[{t:this.polar_head_6}]},2).to({state:[{t:this.polar_head_7}]},2).to({state:[{t:this.polar_head_8}]},2).to({state:[{t:this.polar_head_9}]},2).to({state:[{t:this.polar_head_9}]},2).to({state:[{t:this.polar_head_9}]},2).to({state:[{t:this.polar_head_9}]},16).to({state:[{t:this.polar_head_8}]},2).to({state:[{t:this.polar_head_6}]},2).to({state:[{t:this.polar_head_6}]},2).to({state:[{t:this.polar_head_6}]},2).to({state:[{t:this.polar_head_5}]},2).to({state:[{t:this.polar_head_10}]},2).to({state:[{t:this.polar_head_4}]},37).to({state:[{t:this.polar_head_5}]},4).to({state:[{t:this.polar_head_5}]},2).to({state:[{t:this.polar_head_6}]},2).to({state:[{t:this.polar_head_7}]},2).to({state:[{t:this.polar_head_8}]},2).to({state:[{t:this.polar_head_9}]},2).to({state:[{t:this.polar_head_9}]},2).to({state:[{t:this.polar_head_9}]},2).to({state:[{t:this.polar_head_9}]},16).to({state:[{t:this.polar_head_8}]},2).to({state:[{t:this.polar_head_6}]},2).to({state:[{t:this.polar_head_6}]},2).to({state:[{t:this.polar_head_6}]},2).to({state:[{t:this.polar_head_5}]},2).to({state:[{t:this.polar_head_10}]},2).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.polar_head).to({_off:true},16).wait(48).to({_off:false},0).wait(18).to({_off:true},16).wait(48).to({_off:false},0).to({_off:true},42).wait(18).to({_off:false},0).to({_off:true},20).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.polar_head_2).wait(18).to({_off:false},0).wait(2).to({x:240.7,y:34.2},0).wait(2).to({x:240.1,y:32.9},0).wait(2).to({x:239.6,y:31.6},0).wait(32).to({x:240.1,y:33.2},0).wait(2).to({x:240.7,y:34.8},0).wait(2).to({x:241.2,y:36.4},0).to({_off:true},2).wait(38).to({_off:false,y:35.5},0).wait(2).to({x:240.7,y:34.2},0).wait(2).to({x:240.1,y:32.9},0).wait(2).to({x:239.6,y:31.6},0).wait(32).to({x:240.1,y:33.2},0).wait(2).to({x:240.7,y:34.8},0).wait(2).to({x:241.2,y:36.4},0).to({_off:true},2).wait(219));
	this.timeline.addTween(cjs.Tween.get(this.polar_head_5).wait(234).to({_off:false},0).wait(2).to({skewX:-1.8,skewY:178.2,x:242.6,y:38},0).to({_off:true},2).wait(36).to({_off:false,skewX:0,skewY:180,x:242.7,y:35.2},0).to({_off:true},2).wait(41).to({_off:false,x:244.3,y:34.4},0).wait(2).to({skewX:-1.8,skewY:178.2,x:242.6,y:38},0).to({_off:true},2).wait(36).to({_off:false,skewX:0,skewY:180,x:242.7,y:35.2},0).to({_off:true},2).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.polar_head_6).wait(238).to({_off:false},0).to({_off:true},2).wait(28).to({_off:false,skewX:0,skewY:180,x:239.6,y:31.6},0).wait(2).to({x:240.4,y:34},0).wait(2).to({x:241.2,y:36.4},0).to({_off:true},2).wait(47).to({_off:false,skewX:-3.7,skewY:176.3,x:240.9,y:41.7},0).to({_off:true},2).wait(28).to({_off:false,skewX:0,skewY:180,x:239.6,y:31.6},0).wait(2).to({x:240.4,y:34},0).wait(2).to({x:241.2,y:36.4},0).to({_off:true},2).wait(6));
	this.timeline.addTween(cjs.Tween.get(this.polar_head_9).wait(244).to({_off:false},0).wait(2).to({skewX:40.6,skewY:-139.4,x:247.7,y:23.6},0).wait(2).to({skewX:44,skewY:-136,x:248.7,y:22.8},0).wait(16).to({_off:true},2).wait(61).to({_off:false,skewX:37.5,skewY:-142.5,x:246.6,y:24.4},0).wait(2).to({skewX:40.6,skewY:-139.4,x:247.7,y:23.6},0).wait(2).to({skewX:44,skewY:-136,x:248.7,y:22.8},0).wait(16).to({_off:true},2).wait(14));

	// Polar Bear Front Leg
	this.polar_frontleg = new lib.PolarBearFrontLeg();
	this.polar_frontleg.parent = this;
	this.polar_frontleg.setTransform(270.5,58.4,0.25,0.25,0,4.3,180);

	this.polar_frontleg_1 = new lib.polarbear_excited_ltarm_001();
	this.polar_frontleg_1.parent = this;
	this.polar_frontleg_1.setTransform(269,78.7,0.25,0.25,0,4.3,180,0.1,81.2);

	this.polar_frontleg_2 = new lib.PolarBearFront_excited_roar_001_1();
	this.polar_frontleg_2.parent = this;
	this.polar_frontleg_2.setTransform(269.7,59.1,0.25,0.242,0,2,180);
	this.polar_frontleg_2._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.polar_frontleg}]}).to({state:[{t:this.polar_frontleg}]},16).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},30).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},18).to({state:[{t:this.polar_frontleg}]},16).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},30).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},2).to({state:[{t:this.polar_frontleg}]},42).to({state:[{t:this.polar_frontleg}]},18).to({state:[{t:this.polar_frontleg_1}]},20).to({state:[{t:this.polar_frontleg_2}]},8).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},16).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_1}]},37).to({state:[{t:this.polar_frontleg_2}]},4).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},16).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).to({state:[{t:this.polar_frontleg_2}]},2).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.polar_frontleg).wait(16).to({scaleY:0.24,skewX:2,x:269.7,y:59.1},0).wait(2).to({scaleY:0.23,skewX:0,x:268.9,y:59.8},0).wait(2).to({scaleY:0.24,y:59.3},0).wait(2).to({scaleY:0.25,y:58.9},0).wait(2).to({scaleY:0.25,y:58.4},0).wait(32).to({scaleY:0.25,y:58.9},0).wait(2).to({scaleY:0.24,y:59.3},0).wait(2).to({scaleY:0.23,y:59.8},0).wait(2).to({scaleY:0.24,skewX:2,x:269.7,y:59.1},0).wait(2).to({scaleY:0.25,skewX:4.3,x:270.5,y:58.4},0).wait(34).to({scaleY:0.24,skewX:2,x:269.7,y:59.1},0).wait(2).to({scaleY:0.23,skewX:0,x:268.9,y:59.8},0).wait(2).to({scaleY:0.24,y:59.3},0).wait(2).to({scaleY:0.25,y:58.9},0).wait(2).to({scaleY:0.25,y:58.4},0).wait(32).to({scaleY:0.25,y:58.9},0).wait(2).to({scaleY:0.24,y:59.3},0).wait(2).to({scaleY:0.23,y:59.8},0).wait(2).to({scaleY:0.24,skewX:2,x:269.7,y:59.1},0).wait(2).to({scaleY:0.25,skewX:4.3,x:270.5,y:58.4},0).wait(60).to({_off:true},20).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.polar_frontleg_2).wait(234).to({_off:false},0).wait(2).to({scaleY:0.23,skewX:0,x:268.9,y:60.1},0).wait(2).to({scaleY:0.22,skewX:-2.3,x:268.1,y:61},0).wait(2).to({scaleY:0.25,skewX:-4.8,x:267,y:58.9},0).wait(2).to({scaleY:0.26,skewX:0,x:268.8,y:57.8},0).wait(2).to({scaleY:0.27,skewX:4.5,x:270.7,y:56.6},0).wait(2).to({scaleY:0.27,skewX:5,x:271,y:56.4},0).wait(2).to({scaleY:0.28,skewX:5.9,x:271.3,y:56.1},0).wait(18).to({scaleY:0.26,skewX:2.8,x:270.1,y:57.3},0).wait(2).to({scaleY:0.25,skewX:0,x:268.9,y:58.4},0).wait(2).to({scaleY:0.24,y:59.1},0).wait(2).to({scaleY:0.23,y:59.8},0).wait(2).to({scaleY:0.24,skewX:2,x:269.7,y:59.1},0).wait(2).to({scaleY:0.25,skewX:4.3,x:270.5,y:58.4},0).to({_off:true},37).wait(4).to({_off:false,scaleY:0.24,skewX:2,x:269.7,y:59.1},0).wait(2).to({scaleY:0.23,skewX:0,x:268.9,y:60.1},0).wait(2).to({scaleY:0.22,skewX:-2.3,x:268.1,y:61},0).wait(2).to({scaleY:0.25,skewX:-4.8,x:267,y:58.9},0).wait(2).to({scaleY:0.26,skewX:0,x:268.8,y:57.8},0).wait(2).to({scaleY:0.27,skewX:4.5,x:270.7,y:56.6},0).wait(2).to({scaleY:0.27,skewX:5,x:271,y:56.4},0).wait(2).to({scaleY:0.28,skewX:5.9,x:271.3,y:56.1},0).wait(18).to({scaleY:0.26,skewX:2.8,x:270.1,y:57.3},0).wait(2).to({scaleY:0.25,skewX:0,x:268.9,y:58.4},0).wait(2).to({scaleY:0.24,y:59.1},0).wait(2).to({scaleY:0.23,y:59.8},0).wait(2).to({scaleY:0.24,skewX:2,x:269.7,y:59.1},0).wait(2).to({scaleY:0.25,skewX:4.3,x:270.5,y:58.4},0).wait(4));

	// Polar Bear Hind Leg
	this.polar_hindleg = new lib.PolarBearHindLeg();
	this.polar_hindleg.parent = this;
	this.polar_hindleg.setTransform(306.6,54,0.25,0.25,0,4.3,180);

	this.timeline.addTween(cjs.Tween.get(this.polar_hindleg).wait(16).to({scaleY:0.24,skewX:2,x:305.6,y:54.8},0).wait(2).to({scaleY:0.23,skewX:0,x:304.6,y:55.6},0).wait(2).to({scaleY:0.24,y:55.1},0).wait(2).to({scaleY:0.25,y:54.6},0).wait(2).to({scaleY:0.25,y:54},0).wait(32).to({scaleY:0.25,y:54.6},0).wait(2).to({scaleY:0.24,y:55.1},0).wait(2).to({scaleY:0.23,y:55.6},0).wait(2).to({scaleY:0.24,skewX:2,x:305.6,y:54.8},0).wait(2).to({scaleY:0.25,skewX:4.3,x:306.6,y:54},0).wait(34).to({scaleY:0.24,skewX:2,x:305.6,y:54.8},0).wait(2).to({scaleY:0.23,skewX:0,x:304.6,y:55.6},0).wait(2).to({scaleY:0.24,y:55.1},0).wait(2).to({scaleY:0.25,y:54.6},0).wait(2).to({scaleY:0.25,y:54},0).wait(32).to({scaleY:0.25,y:54.6},0).wait(2).to({scaleY:0.24,y:55.1},0).wait(2).to({scaleY:0.23,y:55.6},0).wait(2).to({scaleY:0.24,skewX:2,x:305.6,y:54.8},0).wait(2).to({scaleY:0.25,skewX:4.3,x:306.6,y:54},0).wait(80).to({regX:3.4,regY:103.6,x:303.8,y:79.9},0).wait(8).to({regX:0,regY:0,scaleY:0.24,skewX:2,x:305.6,y:54.8},0).wait(2).to({scaleY:0.24,skewX:0,x:304.7,y:55.2},0).wait(2).to({scaleY:0.24,skewX:-1.8,x:303.8,y:55.6},0).wait(2).to({scaleY:0.25,skewX:-2.9,x:303.2,y:54.6},0).wait(2).to({scaleY:0.25,skewX:1.5,x:305.3,y:54.3},0).wait(2).to({scaleY:0.25,skewX:6,x:307.4,y:54},0).wait(2).to({skewX:6.5,x:307.7},0).wait(2).to({scaleY:0.25,skewX:7.2,x:307.9},0).wait(18).to({scaleY:0.25,skewX:3.5,x:306.3},0).wait(2).to({scaleY:0.25,skewX:0,x:304.6},0).wait(2).to({scaleY:0.24,y:54.8},0).wait(2).to({scaleY:0.23,y:55.6},0).wait(2).to({scaleY:0.24,skewX:2,x:305.6,y:54.8},0).wait(2).to({scaleY:0.25,skewX:4.3,x:306.6,y:54},0).wait(37).to({regX:3.4,regY:103.6,x:303.8,y:79.9},0).wait(4).to({regX:0,regY:0,scaleY:0.24,skewX:2,x:305.6,y:54.8},0).wait(2).to({scaleY:0.24,skewX:0,x:304.7,y:55.2},0).wait(2).to({scaleY:0.24,skewX:-1.8,x:303.8,y:55.6},0).wait(2).to({scaleY:0.25,skewX:-2.9,x:303.2,y:54.6},0).wait(2).to({scaleY:0.25,skewX:1.5,x:305.3,y:54.3},0).wait(2).to({scaleY:0.25,skewX:6,x:307.4,y:54},0).wait(2).to({skewX:6.5,x:307.7},0).wait(2).to({scaleY:0.25,skewX:7.2,x:307.9},0).wait(18).to({scaleY:0.25,skewX:3.5,x:306.3},0).wait(2).to({scaleY:0.25,skewX:0,x:304.6},0).wait(2).to({scaleY:0.24,y:54.8},0).wait(2).to({scaleY:0.23,y:55.6},0).wait(2).to({scaleY:0.24,skewX:2,x:305.6,y:54.8},0).wait(2).to({scaleY:0.25,skewX:4.3,x:306.6,y:54},0).wait(4));

	// Polar Bear Neck
	this.instance_6 = new lib.PolarBearNeck_1();
	this.instance_6.parent = this;
	this.instance_6.setTransform(256.2,35.6,0.25,0.25,0,0,180);

	this.instance_7 = new lib.PolarBearNeck_wet_1();
	this.instance_7.parent = this;
	this.instance_7.setTransform(256.2,35.6,0.25,0.25,0,0,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance_6}]}).to({state:[{t:this.instance_6}]},16).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},30).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},18).to({state:[{t:this.instance_6}]},16).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},30).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_7}]},42).to({state:[{t:this.instance_6}]},18).to({state:[{t:this.instance_6}]},20).to({state:[{t:this.instance_6}]},8).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},16).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},37).to({state:[{t:this.instance_6}]},4).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},16).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).to({state:[{t:this.instance_6}]},2).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.instance_6).wait(16).to({x:256.4,y:36.9},0).wait(2).to({x:256.5,y:38.1},0).wait(2).to({x:256.4,y:37.3},0).wait(2).to({x:256.3,y:36.4},0).wait(2).to({x:256.2,y:35.6},0).wait(32).to({x:256.3,y:36.4},0).wait(2).to({x:256.4,y:37.3},0).wait(2).to({x:256.5,y:38.1},0).wait(2).to({x:256.4,y:36.9},0).wait(2).to({x:256.2,y:35.6},0).wait(34).to({x:256.4,y:36.9},0).wait(2).to({x:256.5,y:38.1},0).wait(2).to({x:256.4,y:37.3},0).wait(2).to({x:256.3,y:36.4},0).wait(2).to({x:256.2,y:35.6},0).wait(32).to({x:256.3,y:36.4},0).wait(2).to({x:256.4,y:37.3},0).wait(2).to({x:256.5,y:38.1},0).wait(2).to({x:256.4,y:36.9},0).wait(2).to({x:256.2,y:35.6},0).to({_off:true},42).wait(18).to({_off:false},0).wait(20).to({regX:-41.7,regY:1.2,x:266.6,y:35.9},0).wait(8).to({regX:0,regY:0,x:256.4,y:36.9},0).wait(2).to({skewX:-1.8,skewY:178.2,x:256.3,y:40.1},0).wait(2).to({skewX:-3.7,skewY:176.3,y:43.2},0).wait(2).to({scaleX:0.26,skewX:0,skewY:180,x:250.8,y:36.4},0).wait(2).to({scaleX:0.28,scaleY:0.26,skewX:7.3,skewY:187.3,x:253.7,y:34.4},0).wait(2).to({scaleX:0.3,scaleY:0.27,skewX:15,skewY:195,x:256.6,y:32.5},0).wait(2).to({scaleX:0.29,skewX:19,skewY:197.3,y:32.3},0).wait(2).to({scaleX:0.28,scaleY:0.27,skewX:23.1,skewY:199.7,y:32.1},0).wait(18).to({scaleX:0.27,scaleY:0.26,skewX:11.5,skewY:189.8,x:256.5,y:33.9},0).wait(2).to({scaleX:0.25,scaleY:0.25,skewX:0,skewY:180,x:256.2,y:35.6},0).wait(2).to({x:256.4,y:36.9},0).wait(2).to({x:256.5,y:38.1},0).wait(2).to({x:256.4,y:36.9},0).wait(2).to({x:256.2,y:35.6},0).wait(37).to({regX:-41.7,regY:1.2,x:266.6,y:35.9},0).wait(4).to({regX:0,regY:0,x:256.4,y:36.9},0).wait(2).to({skewX:-1.8,skewY:178.2,x:256.3,y:40.1},0).wait(2).to({skewX:-3.7,skewY:176.3,y:43.2},0).wait(2).to({scaleX:0.26,skewX:0,skewY:180,x:250.8,y:36.4},0).wait(2).to({scaleX:0.28,scaleY:0.26,skewX:7.3,skewY:187.3,x:253.7,y:34.4},0).wait(2).to({scaleX:0.3,scaleY:0.27,skewX:15,skewY:195,x:256.6,y:32.5},0).wait(2).to({scaleX:0.29,skewX:19,skewY:197.3,y:32.3},0).wait(2).to({scaleX:0.28,scaleY:0.27,skewX:23.1,skewY:199.7,y:32.1},0).wait(18).to({scaleX:0.27,scaleY:0.26,skewX:11.5,skewY:189.8,x:256.5,y:33.9},0).wait(2).to({scaleX:0.25,scaleY:0.25,skewX:0,skewY:180,x:256.2,y:35.6},0).wait(2).to({x:256.4,y:36.9},0).wait(2).to({x:256.5,y:38.1},0).wait(2).to({x:256.4,y:36.9},0).wait(2).to({x:256.2,y:35.6},0).wait(4));

	// Polar Bear Tail
	this.instance_8 = new lib.PolarBearTail_1();
	this.instance_8.parent = this;
	this.instance_8.setTransform(307,40.2,0.25,0.25,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance_8).wait(18).to({scaleX:0.25,scaleY:0.25,skewX:-5.2,skewY:177.4,x:305.3,y:41.6},0).wait(2).to({scaleY:0.25,skewX:-3.3,skewY:178.2,x:305.1,y:41.1},0).wait(2).to({skewX:-1.6,skewY:179.2,x:304.9,y:40.7},0).wait(2).to({scaleX:0.25,skewX:0,skewY:180,x:304.7,y:40.2},0).wait(32).to({scaleX:0.25,skewX:-1.6,skewY:179.2,x:304.9,y:40.7},0).wait(2).to({skewX:-3.3,skewY:178.2,x:305.1,y:41.1},0).wait(2).to({scaleY:0.25,skewX:-5.2,skewY:177.4,x:305.3,y:41.6},0).wait(2).to({scaleY:0.25,skewX:-2.5,skewY:178.7,x:306.2,y:40.9},0).wait(2).to({scaleX:0.25,skewX:0,skewY:180,x:307,y:40.2},0).wait(34).to({scaleX:0.25,skewX:-2.5,skewY:178.7,x:306.2,y:40.9},0).wait(2).to({scaleY:0.25,skewX:-5.2,skewY:177.4,x:305.3,y:41.6},0).wait(2).to({scaleY:0.25,skewX:-3.3,skewY:178.2,x:305.1,y:41.1},0).wait(2).to({skewX:-1.6,skewY:179.2,x:304.9,y:40.7},0).wait(2).to({scaleX:0.25,skewX:0,skewY:180,x:304.7,y:40.2},0).wait(32).to({scaleX:0.25,skewX:-1.6,skewY:179.2,x:304.9,y:40.7},0).wait(2).to({skewX:-3.3,skewY:178.2,x:305.1,y:41.1},0).wait(2).to({scaleY:0.25,skewX:-5.2,skewY:177.4,x:305.3,y:41.6},0).wait(2).to({scaleY:0.25,skewX:-2.5,skewY:178.7,x:306.2,y:40.9},0).wait(2).to({scaleX:0.25,skewX:0,skewY:180,x:307,y:40.2},0).wait(90).to({scaleX:0.25,skewX:-2.5,skewY:178.7,x:305.5,y:40.4},0).wait(2).to({scaleY:0.25,skewX:-5.2,skewY:177.4,x:304.1,y:40.6},0).wait(2).to({x:303.7,y:39.7},0).wait(2).to({scaleY:0.25,skewX:-2.5,skewY:178.7,x:306.3,y:40},0).wait(2).to({scaleX:0.25,skewX:0,skewY:180,x:308.9,y:40.2},0).wait(2).to({skewX:2.3,skewY:182.3},0).wait(2).to({skewX:4.9,skewY:184.9},0).wait(18).to({skewX:2.3,skewY:182.3,x:308.2,y:40.1},0).wait(2).to({skewX:0,skewY:180,x:307.5,y:40.2},0).wait(2).to({scaleX:0.25,skewX:-2.5,skewY:178.7,x:307,y:40.9},0).wait(2).to({scaleY:0.25,skewX:-5.2,skewY:177.4,x:306.5,y:41.6},0).wait(2).to({scaleY:0.25,skewX:-2.5,skewY:178.7,x:306.7,y:40.9},0).wait(2).to({scaleX:0.25,skewX:0,skewY:180,x:307,y:40.2},0).wait(43).to({scaleX:0.25,skewX:-2.5,skewY:178.7,x:305.5,y:40.4},0).wait(2).to({scaleY:0.25,skewX:-5.2,skewY:177.4,x:304.1,y:40.6},0).wait(2).to({x:303.7,y:39.7},0).wait(2).to({scaleY:0.25,skewX:-2.5,skewY:178.7,x:306.3,y:40},0).wait(2).to({scaleX:0.25,skewX:0,skewY:180,x:308.9,y:40.2},0).wait(2).to({skewX:2.3,skewY:182.3},0).wait(2).to({skewX:4.9,skewY:184.9},0).wait(18).to({skewX:2.3,skewY:182.3,x:308.2,y:40.1},0).wait(2).to({skewX:0,skewY:180,x:307.5,y:40.2},0).wait(2).to({scaleX:0.25,skewX:-2.5,skewY:178.7,x:307,y:40.9},0).wait(2).to({scaleY:0.25,skewX:-5.2,skewY:177.4,x:306.5,y:41.6},0).wait(2).to({scaleY:0.25,skewX:-2.5,skewY:178.7,x:306.7,y:40.9},0).wait(2).to({scaleX:0.25,skewX:0,skewY:180,x:307,y:40.2},0).wait(4));

	// Polar Bear Torso
	this.polar_torso = new lib.PolarBearTorso();
	this.polar_torso.parent = this;
	this.polar_torso.setTransform(292.4,40.3,0.25,0.25,0,0,180);

	this.polar_torso_1 = new lib.PolarBearTorso_wet();
	this.polar_torso_1.parent = this;
	this.polar_torso_1.setTransform(292.4,40.3,0.25,0.25,0,0,180);

	this.polar_torso_2 = new lib.polarbear_excited_torso_001_1();
	this.polar_torso_2.parent = this;
	this.polar_torso_2.setTransform(331.8,41.4,0.25,0.25,0,0,180,-157.8,4.6);
	this.polar_torso_2._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.polar_torso}]}).to({state:[{t:this.polar_torso}]},16).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},30).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},18).to({state:[{t:this.polar_torso}]},16).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},30).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso}]},2).to({state:[{t:this.polar_torso_1}]},42).to({state:[{t:this.polar_torso}]},18).to({state:[{t:this.polar_torso_2}]},20).to({state:[{t:this.polar_torso_2}]},8).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},16).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},37).to({state:[{t:this.polar_torso_2}]},4).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},16).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).to({state:[{t:this.polar_torso_2}]},2).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.polar_torso).wait(16).to({scaleX:0.25,skewX:-2.5,skewY:178.7,x:292.8,y:41.3},0).wait(2).to({scaleY:0.25,skewX:-5.2,skewY:177.4,x:293.1,y:42.3},0).wait(2).to({scaleY:0.25,skewX:-3.3,skewY:178.2,x:292.9,y:41.7},0).wait(2).to({skewX:-1.6,skewY:179.2,x:292.6,y:40.9},0).wait(2).to({scaleX:0.25,skewX:0,skewY:180,x:292.4,y:40.3},0).wait(32).to({scaleX:0.25,skewX:-1.6,skewY:179.2,x:292.6,y:40.9},0).wait(2).to({skewX:-3.3,skewY:178.2,x:292.9,y:41.7},0).wait(2).to({scaleY:0.25,skewX:-5.2,skewY:177.4,x:293.1,y:42.3},0).wait(2).to({scaleY:0.25,skewX:-2.5,skewY:178.7,x:292.8,y:41.3},0).wait(2).to({scaleX:0.25,skewX:0,skewY:180,x:292.4,y:40.3},0).wait(34).to({scaleX:0.25,skewX:-2.5,skewY:178.7,x:292.8,y:41.3},0).wait(2).to({scaleY:0.25,skewX:-5.2,skewY:177.4,x:293.1,y:42.3},0).wait(2).to({scaleY:0.25,skewX:-3.3,skewY:178.2,x:292.9,y:41.7},0).wait(2).to({skewX:-1.6,skewY:179.2,x:292.6,y:40.9},0).wait(2).to({scaleX:0.25,skewX:0,skewY:180,x:292.4,y:40.3},0).wait(32).to({scaleX:0.25,skewX:-1.6,skewY:179.2,x:292.6,y:40.9},0).wait(2).to({skewX:-3.3,skewY:178.2,x:292.9,y:41.7},0).wait(2).to({scaleY:0.25,skewX:-5.2,skewY:177.4,x:293.1,y:42.3},0).wait(2).to({scaleY:0.25,skewX:-2.5,skewY:178.7,x:292.8,y:41.3},0).wait(2).to({scaleX:0.25,skewX:0,skewY:180,x:292.4,y:40.3},0).to({_off:true},42).wait(18).to({_off:false},0).to({_off:true},20).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.polar_torso_2).wait(226).to({_off:false},0).wait(8).to({regX:0,regY:0,scaleX:0.25,skewX:-2.5,skewY:178.7,x:292.8,y:41.3},0).wait(2).to({skewX:-5.6,skewY:176.2,x:292.2,y:43.2},0).wait(2).to({scaleY:0.25,skewX:-8.9,skewY:173.6,x:291.5,y:45.1},0).wait(2).to({scaleX:0.26,scaleY:0.25,skewX:-1.6,skewY:179.2,x:288.5,y:40.9},0).wait(2).to({scaleX:0.25,skewX:0.8,skewY:181.3,x:290.4,y:40.7},0).wait(2).to({scaleX:0.25,skewX:3.5,skewY:183.5,x:292.4,y:40.3},0).wait(2).to({skewX:5.3,skewY:183.3,y:40.2},0).wait(2).to({skewX:7.1,skewY:183.5,y:40.3},0).wait(18).to({skewX:3.5,skewY:181.6,y:40.2},0).wait(2).to({skewX:0,skewY:180,y:40.3},0).wait(2).to({scaleX:0.25,skewX:-2.5,skewY:178.7,x:292.1,y:41.3},0).wait(2).to({scaleY:0.25,skewX:-5.2,skewY:177.4,x:291.9,y:42.3},0).wait(2).to({scaleY:0.25,skewX:-2.5,skewY:178.7,x:292.2,y:41.2},0).wait(2).to({scaleX:0.25,skewX:0,skewY:180,x:292.4,y:40.3},0).wait(37).to({regX:-157.8,regY:4.6,x:331.8,y:41.4},0).wait(4).to({regX:0,regY:0,scaleX:0.25,skewX:-2.5,skewY:178.7,x:292.8,y:41.3},0).wait(2).to({skewX:-5.6,skewY:176.2,x:292.2,y:43.2},0).wait(2).to({scaleY:0.25,skewX:-8.9,skewY:173.6,x:291.5,y:45.1},0).wait(2).to({scaleX:0.26,scaleY:0.25,skewX:-1.6,skewY:179.2,x:288.5,y:40.9},0).wait(2).to({scaleX:0.25,skewX:0.8,skewY:181.3,x:290.4,y:40.7},0).wait(2).to({scaleX:0.25,skewX:3.5,skewY:183.5,x:292.4,y:40.3},0).wait(2).to({skewX:5.3,skewY:183.3,y:40.2},0).wait(2).to({skewX:7.1,skewY:183.5,y:40.3},0).wait(18).to({skewX:3.5,skewY:181.6,y:40.2},0).wait(2).to({skewX:0,skewY:180,y:40.3},0).wait(2).to({scaleX:0.25,skewX:-2.5,skewY:178.7,x:292.1,y:41.3},0).wait(2).to({scaleY:0.25,skewX:-5.2,skewY:177.4,x:291.9,y:42.3},0).wait(2).to({scaleY:0.25,skewX:-2.5,skewY:178.7,x:292.2,y:41.2},0).wait(2).to({scaleX:0.25,skewX:0,skewY:180,x:292.4,y:40.3},0).wait(4));

	// Polar Bear Front Leg Back
	this.polar_frontlegback = new lib.PolarBearFrontLegBack_001();
	this.polar_frontlegback.parent = this;
	this.polar_frontlegback.setTransform(256.8,55.4,0.223,0.223,0,4.3,180);

	this.polar_frontlegback_1 = new lib.polarbear_excited_rtarm_001();
	this.polar_frontlegback_1.parent = this;
	this.polar_frontlegback_1.setTransform(250.7,75.9,0.223,0.223,0,4.3,180,20.4,92);

	this.polar_frontlegback_2 = new lib.PolarBearFrontLegBack_excited_roar_001_1();
	this.polar_frontlegback_2.parent = this;
	this.polar_frontlegback_2.setTransform(255.9,56.3,0.223,0.216,0,2,180);
	this.polar_frontlegback_2._off = true;

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.polar_frontlegback}]}).to({state:[{t:this.polar_frontlegback}]},16).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},30).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},18).to({state:[{t:this.polar_frontlegback}]},16).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},30).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},2).to({state:[{t:this.polar_frontlegback}]},42).to({state:[{t:this.polar_frontlegback}]},18).to({state:[{t:this.polar_frontlegback_1}]},20).to({state:[{t:this.polar_frontlegback_2}]},8).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},16).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_1}]},37).to({state:[{t:this.polar_frontlegback_2}]},4).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},16).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).to({state:[{t:this.polar_frontlegback_2}]},2).wait(4));
	this.timeline.addTween(cjs.Tween.get(this.polar_frontlegback).wait(16).to({scaleY:0.22,skewX:2,x:255.9,y:56.3},0).wait(2).to({scaleY:0.21,skewX:0,x:254.9,y:57},0).wait(2).to({scaleY:0.21,y:56.5},0).wait(2).to({scaleY:0.22,y:55.9},0).wait(2).to({scaleY:0.22,y:55.4},0).wait(32).to({scaleY:0.22,y:55.9},0).wait(2).to({scaleY:0.21,y:56.5},0).wait(2).to({scaleY:0.21,y:57},0).wait(2).to({scaleY:0.22,skewX:2,x:255.9,y:56.3},0).wait(2).to({scaleY:0.22,skewX:4.3,x:256.8,y:55.4},0).wait(34).to({scaleY:0.22,skewX:2,x:255.9,y:56.3},0).wait(2).to({scaleY:0.21,skewX:0,x:254.9,y:57},0).wait(2).to({scaleY:0.21,y:56.5},0).wait(2).to({scaleY:0.22,y:55.9},0).wait(2).to({scaleY:0.22,y:55.4},0).wait(32).to({scaleY:0.22,y:55.9},0).wait(2).to({scaleY:0.21,y:56.5},0).wait(2).to({scaleY:0.21,y:57},0).wait(2).to({scaleY:0.22,skewX:2,x:255.9,y:56.3},0).wait(2).to({scaleY:0.22,skewX:4.3,x:256.8,y:55.4},0).wait(60).to({_off:true},20).wait(137));
	this.timeline.addTween(cjs.Tween.get(this.polar_frontlegback_2).wait(234).to({_off:false},0).wait(2).to({scaleY:0.21,skewX:0,x:255,y:57.3},0).wait(2).to({scaleY:0.2,skewX:-2.3,x:254.1,y:58.4},0).wait(2).to({scaleY:0.22,skewX:-4.8,x:252.9,y:55.9},0).wait(2).to({scaleY:0.23,skewX:0,x:255,y:54.7},0).wait(2).to({scaleY:0.24,skewX:4.5,x:257,y:53.4},0).wait(2).to({scaleY:0.25,skewX:5.1,x:257.4,y:53.1},0).wait(2).to({scaleY:0.25,skewX:5.9,x:257.7,y:52.8},0).wait(18).to({scaleY:0.24,skewX:2.8,x:256.3,y:54.1},0).wait(2).to({scaleY:0.22,skewX:0,x:254.9,y:55.4},0).wait(2).to({scaleY:0.22,y:56.2},0).wait(2).to({scaleY:0.21,y:57},0).wait(2).to({scaleY:0.22,skewX:2,x:255.9,y:56.3},0).wait(2).to({scaleY:0.22,skewX:4.3,x:256.8,y:55.4},0).to({_off:true},37).wait(4).to({_off:false,scaleY:0.22,skewX:2,x:255.9,y:56.3},0).wait(2).to({scaleY:0.21,skewX:0,x:255,y:57.3},0).wait(2).to({scaleY:0.2,skewX:-2.3,x:254.1,y:58.4},0).wait(2).to({scaleY:0.22,skewX:-4.8,x:252.9,y:55.9},0).wait(2).to({scaleY:0.23,skewX:0,x:255,y:54.7},0).wait(2).to({scaleY:0.24,skewX:4.5,x:257,y:53.4},0).wait(2).to({scaleY:0.25,skewX:5.1,x:257.4,y:53.1},0).wait(2).to({scaleY:0.25,skewX:5.9,x:257.7,y:52.8},0).wait(18).to({scaleY:0.24,skewX:2.8,x:256.3,y:54.1},0).wait(2).to({scaleY:0.22,skewX:0,x:254.9,y:55.4},0).wait(2).to({scaleY:0.22,y:56.2},0).wait(2).to({scaleY:0.21,y:57},0).wait(2).to({scaleY:0.22,skewX:2,x:255.9,y:56.3},0).wait(2).to({scaleY:0.22,skewX:4.3,x:256.8,y:55.4},0).wait(4));

	// Polar Bear Hind Leg Back
	this.polar_hindlegback = new lib.PolarBearHindLegBack();
	this.polar_hindlegback.parent = this;
	this.polar_hindlegback.setTransform(323.3,52.1,0.236,0.236,0,4.3,180);

	this.timeline.addTween(cjs.Tween.get(this.polar_hindlegback).wait(16).to({scaleY:0.23,skewX:2,x:322.3,y:53},0).wait(2).to({scaleY:0.22,skewX:0,x:321.2,y:53.9},0).wait(2).to({scaleY:0.23,y:53.3},0).wait(2).to({scaleY:0.23,y:52.7},0).wait(2).to({scaleY:0.24,y:52.1},0).wait(32).to({scaleY:0.23,y:52.7},0).wait(2).to({scaleY:0.23,y:53.3},0).wait(2).to({scaleY:0.22,y:53.9},0).wait(2).to({scaleY:0.23,skewX:2,x:322.3,y:53},0).wait(2).to({scaleY:0.24,skewX:4.3,x:323.3,y:52.1},0).wait(34).to({scaleY:0.23,skewX:2,x:322.3,y:53},0).wait(2).to({scaleY:0.22,skewX:0,x:321.2,y:53.9},0).wait(2).to({scaleY:0.23,y:53.3},0).wait(2).to({scaleY:0.23,y:52.7},0).wait(2).to({scaleY:0.24,y:52.1},0).wait(32).to({scaleY:0.23,y:52.7},0).wait(2).to({scaleY:0.23,y:53.3},0).wait(2).to({scaleY:0.22,y:53.9},0).wait(2).to({scaleY:0.23,skewX:2,x:322.3,y:53},0).wait(2).to({scaleY:0.24,skewX:4.3,x:323.3,y:52.1},0).wait(80).to({skewX:2,x:322.1},0).wait(8).to({scaleY:0.23,x:322.3,y:53},0).wait(2).to({scaleY:0.23,skewX:0,x:321.3,y:53.4},0).wait(2).to({scaleY:0.22,skewX:-1.8,x:320.4,y:53.8},0).wait(2).to({scaleY:0.23,skewX:-2.9,x:319.8,y:52.7},0).wait(2).to({scaleY:0.23,skewX:-1,x:320.6,y:52.4},0).wait(2).to({scaleY:0.24,skewX:0.9,x:321.5,y:52.1},0).wait(2).to({skewX:1.3,x:321.8},0).wait(2).to({skewX:2,x:322.1},0).wait(18).to({skewX:1,x:321.7},0).wait(2).to({skewX:0,x:321.2},0).wait(2).to({scaleY:0.23,y:53},0).wait(2).to({scaleY:0.22,y:53.9},0).wait(2).to({scaleY:0.23,y:53},0).wait(2).to({scaleY:0.24,y:52.1},0).wait(37).to({skewX:2,x:322.1},0).wait(4).to({scaleY:0.23,x:322.3,y:53},0).wait(2).to({scaleY:0.23,skewX:0,x:321.3,y:53.4},0).wait(2).to({scaleY:0.22,skewX:-1.8,x:320.4,y:53.8},0).wait(2).to({scaleY:0.23,skewX:-2.9,x:319.8,y:52.7},0).wait(2).to({scaleY:0.23,skewX:-1,x:320.6,y:52.4},0).wait(2).to({scaleY:0.24,skewX:0.9,x:321.5,y:52.1},0).wait(2).to({skewX:1.3,x:321.8},0).wait(2).to({skewX:2,x:322.1},0).wait(18).to({skewX:1,x:321.7},0).wait(2).to({skewX:0,x:321.2},0).wait(2).to({scaleY:0.23,y:53},0).wait(2).to({scaleY:0.22,y:53.9},0).wait(2).to({scaleY:0.23,y:53},0).wait(2).to({scaleY:0.24,y:52.1},0).wait(4));

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(227.5,15.5,109.5,68);


(lib.polarBear = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

	// pawGlow
	this.pawGlow = new lib.polarbear_footGlow();
	this.pawGlow.parent = this;
	this.pawGlow.setTransform(200.3,249.4,1,1,0,0,0,24.3,8.8);
	this.pawGlow.alpha = 0;
	this.pawGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.pawGlow.cache(-49,-16,240,39);

	this.timeline.addTween(cjs.Tween.get(this.pawGlow).wait(1));

	// backGlow
	this.backGlow = new lib.polarbear_backGlow();
	this.backGlow.parent = this;
	this.backGlow.setTransform(264.5,109.2,1.106,1.09,0,3.7,0,77.9,27.7);
	this.backGlow.alpha = 0;
	this.backGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.backGlow.cache(10,0,152,60);

	this.timeline.addTween(cjs.Tween.get(this.backGlow).wait(1));

	// noseGlow
	this.noseGlow = new lib.polarbear_noseGlow();
	this.noseGlow.parent = this;
	this.noseGlow.setTransform(131.9,132.7,1.256,1.118,0,0,0,16.2,18.2);
	this.noseGlow.alpha = 0;
	this.noseGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.noseGlow.cache(-4,-4,42,45);

	this.timeline.addTween(cjs.Tween.get(this.noseGlow).wait(1));

	// legGlow
	this.legGlow = new lib.polarbear_legGlow();
	this.legGlow.parent = this;
	this.legGlow.setTransform(304.8,183.7,1,1,0,0,0,44.1,72.4);
	this.legGlow.alpha = 0;
	this.legGlow.filters = [new cjs.BlurFilter(4, 4, 1)];
	this.legGlow.cache(-113,-3,239,139);

	this.timeline.addTween(cjs.Tween.get(this.legGlow).wait(1));

	// leg3
	this.leg3 = new lib.invisiblebox();
	this.leg3.parent = this;
	this.leg3.setTransform(304.1,162.2,1.847,1.032,0,1.8,2.7);

	this.timeline.addTween(cjs.Tween.get(this.leg3).wait(1));

	// tail
	this.tail = new lib.invisiblebox();
	this.tail.parent = this;
	this.tail.setTransform(362.8,143.1,0.677,1.451,-28);

	this.timeline.addTween(cjs.Tween.get(this.tail).wait(1));

	// leg1
	this.leg1 = new lib.invisiblebox();
	this.leg1.parent = this;
	this.leg1.setTransform(200.2,191.1,2.346,1.361,6);

	this.timeline.addTween(cjs.Tween.get(this.leg1).wait(1));

	// leg2
	this.leg2 = new lib.invisiblebox();
	this.leg2.parent = this;
	this.leg2.setTransform(326.8,207.8,2.946,1.032,0,1.8,2.7);

	this.timeline.addTween(cjs.Tween.get(this.leg2).wait(1));

	// paw4
	this.paw4 = new lib.invisiblebox();
	this.paw4.parent = this;
	this.paw4.setTransform(314.4,246,2.357,0.518,-2.3);

	this.timeline.addTween(cjs.Tween.get(this.paw4).wait(1));

	// paw1
	this.paw1 = new lib.invisiblebox();
	this.paw1.parent = this;
	this.paw1.setTransform(177.1,240.7,2.325,0.694,7.2);

	this.timeline.addTween(cjs.Tween.get(this.paw1).wait(1));

	// neck
	this.neck = new lib.invisiblebox();
	this.neck.parent = this;
	this.neck.setTransform(189.7,121.4,0.405,1.496,3.2);

	this.timeline.addTween(cjs.Tween.get(this.neck).wait(1));

	// back
	this.back = new lib.invisiblebox();
	this.back.parent = this;
	this.back.setTransform(265.8,108.4,2.916,1.43,-2.8);

	this.timeline.addTween(cjs.Tween.get(this.back).wait(1));

	// ear
	this.ear = new lib.invisiblebox();
	this.ear.parent = this;
	this.ear.setTransform(135.4,105.2,1.988,0.648);

	this.timeline.addTween(cjs.Tween.get(this.ear).wait(1));

	// nose
	this.nose = new lib.invisiblebox();
	this.nose.parent = this;
	this.nose.setTransform(118.7,137.8,1.547,0.827);

	this.timeline.addTween(cjs.Tween.get(this.nose).wait(1));

	// main
	this.main = new lib.Polar();
	this.main.parent = this;
	this.main.setTransform(245.9,164.5,2.706,2.706,0,0,0,284.4,46.6);
	this.main.shadow = new cjs.Shadow("rgba(0,0,0,1)",1,0,3);

	this.timeline.addTween(cjs.Tween.get(this.main).wait(1));

}).prototype = getMCSymbolPrototype(lib.polarBear, new cjs.Rectangle(87,76.2,309.8,196), null);


// stage content:
(lib.MWpolar = function(mode,startPosition,loop) {
	this.initialize(mode,startPosition,loop,{});

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = null;
// library properties:
lib.properties = {
	width: 600,
	height: 307,
	fps: 30,
	color: "#0000CC",
	opacity: 1.00,
	manifest: [
		{src:"../../../deploy/assets/images/MWpolar_atlas_.png?1528310059206", id:"MWpolar_atlas_"}
	],
	preloads: []
};




})(lib_Polar = lib_Polar||{}, images = images||{}, createjs = createjs||{}, ss = ss||{}, AdobeAn = AdobeAn||{});
var lib_Polar, images, createjs, ss, AdobeAn;